import type { ContentItem } from '../contentLibrary'

export const WEIJIN_ARTICLES: ContentItem[] = [
  {
    id: 'classic-taohuayuanji',
    category: 'classic',
    dynasty: 'weijin',
    title: '桃花源記',
    source: '陶淵明',
    description: '陶淵明的代表作，描寫了一個與世無爭、和諧安寧的世外桃源。',
    content: '晉太元中，武陵人捕魚為業。緣溪行，忘路之遠近。忽逢桃花林，夾岸數百步，中無雜樹，芳草鮮美，落英繽紛。漁人甚異之，復前行，欲窮其林。林盡水源，便得一山，山有小口，彷彿若有光。便捨船，從口入。初極狹，才通人。復行數十步，豁然開朗。土地平曠，屋舍儼然，有良田、美池、桑竹之屬。阡陌交通，雞犬相聞。其中往來種作，男女衣著，悉如外人。黃髮垂髫，並怡然自樂。見漁人，乃大驚，問所從來。具答之。便要還家，設酒殺雞作食。村中聞有此人，咸來問訊。自雲先世避秦時亂，率妻子邑人來此絕境，不復出焉，遂與外人間隔。問今是何世，乃不知有漢，無論魏晉。此人一一為具言所聞，皆嘆惋。餘人各復延至其家，皆出酒食。停數日，辭去。此中人語云：「不足為外人道也。」既出，得其船，便扶向路，處處誌之。及郡下，詣太守，說如此。太守即遣人隨其往，尋向所誌，遂迷，不復得路。南陽劉子驥，高尚士也，聞之，欣然規往。未果，尋病終。後遂無問津者。',
  },

  {
    id: 'classic-lantingjixu',
    category: 'classic',
    dynasty: 'weijin',
    title: '蘭亭集序',
    source: '王羲之',
    description: '行書名作之序文，記述蘭亭盛會，兼論生死之理，辭理俱妙。',
    content: '永和九年，歲在癸丑，暮春之初，會於會稽山陰之蘭亭，修禊事也。群賢畢至，少長咸集。此地有崇山峻嶺，茂林修竹；又有清流激湍，映帶左右，引以為流觴曲水，列坐其次。雖無絲竹管弦之盛，一觴一詠，亦足以暢敘幽情。是日也，天朗氣清，惠風和暢，仰觀宇宙之大，俯察品類之盛，所以遊目騁懷，極視聽之娛，信可樂也。夫人之相與，俯仰一世，或取諸懷抱，晤言一室之內；或因寄所託，放浪形骸之外。雖趣舍萬殊，靜躁不同，當其欣於所遇，暫得於己，快然自足，不知老之將至。及其所之既倦，情隨事遷，感慨係之矣。向之所欣，俯仰之間，已為陳跡，猶不能不以之興懷。況修短隨化，終期於盡。古人云：「死生亦大矣。」豈不痛哉！每覽昔人興感之由，若合一契，未嘗不臨文嗟悼，不能喻之於心。固知一死生為虛誕，齊彭殤為妄作。後之視今，亦猶今之視昔。悲夫！故列敘時人，錄其所述，雖世殊事異，所以興懷，其致一也。後之覽者，亦將有感於斯文。',
  },

  {
    id: 'classic-qianziwen',
    category: 'classic',
    dynasty: 'weijin',
    title: '千字文',
    source: '蒙學經典',
    description: '適合較長篇幅的連續抄寫。',
    content: '天地玄黃，宇宙洪荒。日月盈昃，辰宿列張。寒來暑往，秋收冬藏。閏餘成歲，律呂調陽。雲騰致雨，露結為霜。金生麗水，玉出崑岡。劍號巨闕，珠稱夜光。果珍李柰，菜重芥薑。海鹹河淡，鱗潛羽翔。龍師火帝，鳥官人皇。始制文字，乃服衣裳。推位讓國，有虞陶唐。弔民伐罪，周發殷湯。坐朝問道，垂拱平章。愛育黎首，臣伏戎羌。遐邇一體，率賓歸王。鳴鳳在竹，白駒食場。化被草木，賴及萬方。蓋此身髮，四大五常。恭惟鞠養，豈敢毀傷。女慕貞潔，男效才良。知過必改，得能莫忘。罔談彼短，靡恃己長。信使可覆，器欲難量。墨悲絲染，詩讚羔羊。景行維賢，克念作聖。德建名立，形端影直。空谷傳聲，虛堂習聽。禍因惡積，福緣善慶。尺璧非寶，寸陰是競。',
  },

  {
    id: 'classic-wuliuxiansheng',
    category: 'classic',
    dynasty: 'weijin',
    title: '五柳先生傳',
    source: '陶淵明',
    description: '陶淵明自況之作，塑造了安貧樂道的隱士形象。',
    content: '先生不知何許人也，亦不詳其姓字，宅邊有五柳樹，因以為號焉。閒靜少言，不慕榮利。好讀書，不求甚解；每有會意，便欣然忘食。性嗜酒，家貧不能常得。親舊知其如此，或置酒而招之；造飲輒盡，期在必醉。既醉而退，曾不吝情去留。環堵蕭然，不蔽風日；短褐穿結，簞瓢屢空，晏如也。常著文章自娛，頗示己志。忘懷得失，以此自終。贊曰：黔婁之妻有言：「不戚戚於貧賤，不汲汲於富貴。」極其言，茲若人之儔乎？銜觴賦詩，以樂其志。無懷氏之民歟？葛天氏之民歟？',
  },

  {
    id: 'classic-guiquxilai',
    category: 'classic',
    dynasty: 'weijin',
    title: '歸去來兮辭',
    source: '陶淵明',
    description: '陶淵明辭官歸隱的宣言，灑脫自在。',
    content: '歸去來兮，田園將蕪胡不歸？既自以心為形役，奚惆悵而獨悲？悟已往之不諫，知來者之可追。實迷途其未遠，覺今是而昨非。舟遙遙以輕颺，風飄飄而吹衣。問征夫以前路，恨晨光之熹微。乃瞻衡宇，載欣載奔。僮僕歡迎，稚子候門。三徑就荒，松菊猶存。攜幼入室，有酒盈樽。引壺觴以自酌，眄庭柯以怡顏。倚南窗以寄傲，審容膝之易安。園日涉以成趣，門雖設而常關。策扶老以流憩，時矯首而遐觀。雲無心以出岫，鳥倦飛而知還。景翳翳以將入，撫孤松而盤桓。歸去來兮，請息交以絕遊。世與我而相違，復駕言兮焉求？悅親戚之情話，樂琴書以消憂。農人告餘以春及，將有事於西疇。或命巾車，或棹孤舟。既窈窕以尋壑，亦崎嶇而經丘。木欣欣以向榮，泉涓涓而始流。善萬物之得時，感吾生之行休。已矣乎！寓形宇內復幾時？曷不委心任去留？胡為乎遑遑欲何之？富貴非吾願，帝鄉不可期。懷良辰以孤往，或植杖而耘耔。登東皋以舒嘯，臨清流而賦詩。聊乘化以歸盡，樂夫天命復奚疑！',
  },

  {
    id: 'classic-qianchushibiao',
    category: 'classic',
    dynasty: 'weijin',
    title: '前出師表',
    source: '諸葛亮',
    description: '諸葛亮出師北伐前上給後主劉禪的表文，言辭懇切，鞠躬盡瘁。',
    content: '臣亮言：先帝創業未半而中道崩殂，今天下三分，益州疲弊，此誠危急存亡之秋也。然侍衛之臣不懈於內，忠志之士忘身於外者，蓋追先帝之殊遇，欲報之於陛下也。誠宜開張聖聽，以光先帝遺德，恢弘志士之氣，不宜妄自菲薄，引喻失義，以塞忠諫之路也。宮中府中，俱為一體，陟罰臧否，不宜異同。若有作奸犯科及為忠善者，宜付有司論其刑賞，以昭陛下平明之理，不宜偏私，使內外異法也。侍中、侍郎郭攸之、費禕、董允等，此皆良實，志慮忠純，是以先帝簡拔以遺陛下。愚以為宮中之事，事無大小，悉以咨之，然後施行，必能裨補闕漏，有所廣益。將軍向寵，性行淑均，曉暢軍事，試用於昔日，先帝稱之曰能，是以眾議舉寵為督。愚以為營中之事，悉以咨之，必能使行陣和睦，優劣得所。親賢臣，遠小人，此先漢所以興隆也；親小人，遠賢臣，此後漢所以傾頹也。先帝在時，每與臣論此事，未嘗不歎息痛恨於桓、靈也。侍中、尚書、長史、參軍，此悉貞良死節之臣，願陛下親之信之，則漢室之隆，可計日而待也。臣本布衣，躬耕於南陽，苟全性命於亂世，不求聞達於諸侯。先帝不以臣卑鄙，猥自枉屈，三顧臣於草廬之中，諮臣以當世之事，由是感激，遂許先帝以驅馳。後值傾覆，受任於敗軍之際，奉命於危難之間，爾來二十有一年矣。先帝知臣謹慎，故臨崩寄臣以大事也。受命以來，夙夜憂歎，恐託付不效，以傷先帝之明，故五月渡瀘，深入不毛。今南方已定，兵甲已足，當獎率三軍，北定中原，庶竭駑鈍，攘除奸凶，興復室，還於舊都。此臣所以報先帝而忠陛下之職分也。至於斟酌損益，進盡忠言，則攸之、禕、允之任也。願陛下託臣以討賊興復之效，不效，則治臣之罪，以告先帝之靈。責攸之、禕、允等之慢，以彰其咎；陛下亦宜自謀，以諮諏善道，察納雅言，深追先帝遺詔。臣不勝受恩感激。今當遠離，臨表涕零，不知所言。',
  },

  {
    id: 'classic-houchushibiao',
    category: 'classic',
    dynasty: 'weijin',
    title: '後出師表',
    source: '諸葛亮',
    description: '諸葛亮第二次北伐前所作，極言討賊之必要，赤誠忠心。',
    content: '先帝慮漢、賊不兩立，王業不偏安，故託臣以討賊也。以先帝之明，量臣之才，固知臣伐賊，才弱敵強也。然不伐賊，王業亦亡。惟坐而待亡，孰與伐之？是故託臣而弗疑也。臣受命之日，寢不安席，食不甘味。思欲北征，宜先入南。故五月渡瀘，深入不毛，並日而食；臣非不自惜也，顧王業不可得偏安於蜀都，故冒危難，以奉先帝之遺意，而議者謂為非計。今賊適疲於西，又務於東，兵法乘勞，此進趨之時也。謹陳其事如左：高帝明並日月，謀臣淵深，然涉險被創，危然後安。今陛下未及高帝，謀臣不如良、平，而欲以長策取勝，坐定天下，此臣之未解一也。劉繇、王朗各據州郡，論安言計，動引聖人，群疑滿腹，眾難塞胸，今歲不戰，明年不戰，使孫策坐大，遂並江東，此臣之未解二也。曹操智計，殊絕於人，其用兵也，彷彿孫、吳，然困於南陽，險於烏巢，窘於祁山，逼於黎陽，幾敗霸王，後乃微定。況臣才弱，而欲以不危而定之，此臣之未解三也。曹操五攻昌霸不下，四越巢湖不成，任用李服而李服圖之，委任夏侯而夏侯敗亡，先帝每稱操為能，猶有此失，況臣駑下，何能必勝？此臣之未解四也。自臣到哈爾濱，自臣到漢中，中間期年耳，然喪趙雲、陽群、馬玉、閻芝、丁立、白壽、劉郃、鄧銅等及曲長、屯將七十餘人，突將、無前、賨叟、青羌、散騎、武騎千餘人。此皆數十年之內所糾合四方之精銳，非一州之所有；若復數年，則損三分之二，當何以圖敵？此臣之未解五也。今民窮兵疲，而事不可息；事不可息，則住與行勞費正等。而不及今圖之，欲以一州之地，與賊持久，此臣之未解六也。夫難平者，事也。昔先帝敗軍於楚，當此之時，曹操拊手，謂天下已定。然後先帝東連吳越，西取巴蜀，舉兵北征，夏侯授首，此操之失計，而漢事將成也。然後吳更違盟，關羽毀敗，秭歸蹉跌，曹丕稱帝。凡事如是，難可逆見。臣鞠躬盡瘁，死後已；至於成敗利鈍，非臣之明所能逆睹也。',
  },

  {
    id: 'classic-chenqingbiao',
    category: 'classic',
    dynasty: 'weijin',
    title: '陳情表',
    source: '李密',
    description: '李密辭官養祖母的至孝之文，真摯感人。',
    content: '臣以險釁，夙遭閔凶。生孩六月，慈父見背；行年四歲，舅奪母志。祖母劉憫臣孤弱，躬親撫養。臣少多疾病，九歲不行，零丁孤苦，至於成立。既無叔伯，終鮮兄弟，門衰祚薄，晚有兒息。外無期功強近之親，內無應門五尺之僮，煢煢孑立，形影相弔。而劉夙嬰疾病，常在床蓐，臣侍湯藥，未曾廢離。逮奉聖朝，沐浴清化。前太守臣逵察臣孝廉；後刺史臣榮舉臣秀才。臣以供養無主，辭不赴命。詔書特下，拜臣郎中，尋蒙國恩，除臣洗馬。非獨蜀之人士及二州牧伯所見明知，皇天后土，實所共鑒。願陛下矜憫愚誠，聽臣微志，庶劉僥倖，保卒餘年。臣生當隕首，死當結草。臣不勝犬馬怖懼之情，謹拜表以聞。',
  },

  {
    id: 'poem-qibushi',
    category: 'poem',
    dynasty: 'weijin',
    title: '七步詩',
    source: '曹植',
    description: '曹植七步之內成詩，以豆萁相煎喻手足相殘。',
    content: '煮豆燃豆萁，豆在釜中泣。本是同根生，相煎何太急。',
  },

  {
    id: 'classic-dianlunlunwen',
    category: 'classic',
    dynasty: 'weijin',
    title: '典論論文',
    source: '曹丕',
    description: '曹丕首開文學批評先河，論文人相輕、文氣不同，為魏晉文學自覺之標誌。',
    content: '文人相輕，自古而然。傅毅之於班固，伯仲之間耳，而固小之，與弟超書曰：「武仲以能屬文，為蘭臺令史，下筆不能自休。」夫人善於自見，而文非一體，鮮能備善，是以各以所長，相輕所短。里語曰：「家有弊帚，享之千金。」斯不自見之患也。\n今之文人：魯國孔融文舉、廣陵陳琳孔璋、山陽王粲仲宣、北海徐幹偉長、陳留阮瑀元瑜、汝南應瑒德璉、東平劉楨公幹。斯七子者，於學無所遺，於辭無所假，咸以自騁驥騄於千里，仰齊足而並馳，以此相服，亦良難矣。蓋君子審己以度人，故能免於斯累而作論文。\n王粲長於辭賦，徐幹時有齊氣，然粲之匹也。如粲之初征、登樓、槐賦、征思，幹之玄猿、漏巵、圓扇、橘賦，雖張、蔡不過也。然於他文，未能稱是。琳、瑀之章表書記，今之雋也。應瑒和而不壯，劉楨壯而不密。孔融體氣高妙，有過人者，然不能持論，理不勝辭，以至乎雜以嘲戲。及其所善，揚、班儔也。\n常人貴遠賤近，向聲背實，又患闇於自見，謂己為賢。\n夫文，本同而末異。蓋奏議宜雅，書論宜理，銘誄尚實，詩賦欲麗。此四科不同，故能之者偏也；唯通才能備其體。\n文以氣為主，氣之清濁有體，不可力強而致。譬諸音樂，曲度雖均，節奏同檢，至於引氣不齊，巧拙有素，雖在父兄，不能以移子弟。\n蓋文章，經國之大業，不朽之盛事。年壽有時而盡，榮樂止乎其身，二者必至之常期，未若文章之無窮。是以古之作者，寄身於翰墨，見意於篇籍，不假良史之辭，不託飛馳之勢，而聲名自傳於後。故西伯幽而演易，周旦顯而制禮，不以隱約而弗務，不以康樂而加思。夫然，則古人賤尺璧而重寸陰，懼乎時之過已。而人多不強力；貧賤則懾於飢寒，富貴則流於逸樂，遂營目前之務，而遺千載之功。日月逝於上，體貌衰於下，忽然與萬物遷化，斯志士之大痛也！\n融等已逝，唯幹著論，成一家言。',
  },

  {
    id: 'classic-hanjin-zhugeliang',
    category: 'classic',
    dynasty: 'weijin',
    title: '誡子書',
    source: '諸葛亮',
    description: '諸葛亮告誡子嗣修身立德、澹泊寧靜的名篇。',
    content: '夫君子之行，靜以修身，儉以養德。非澹泊無以明志，非寧靜無以致遠。夫學須靜也，才須學也，非學無以廣才，非志無以成學。淫慢則不能勵精，險躁則不能治性。年與時馳，意與日去，遂成枯落，多不接世，悲守窮廬，將復何及！',
  },

  {
    id: 'poem-hanjin-caocao',
    category: 'poem',
    dynasty: 'weijin',
    title: '短歌行',
    source: '曹操',
    description: '曹操憂思人生、求賢若渴的慷慨之作。',
    content: '對酒當歌，人生幾何！譬如朝露，去日苦多。慨當以慷，憂思難忘。何以解憂？唯有杜康。青青子衿，悠悠我心。但為君故，沉吟至今。',
  },

  {
    id: 'poem-hanjin-taoyuanming',
    category: 'poem',
    dynasty: 'weijin',
    title: '飲酒·其五',
    source: '陶淵明',
    description: '陶淵明歸隱田園、物我兩忘的超然意境。',
    content: '結廬在人境，而無車馬喧。問君何能爾？心遠地自偏。採菊東籬下，悠然見南山。山氣日夕佳，飛鳥相與還。此中有真意，欲辨已忘言。',
  },

  {
    id: 'poem-hanjin-baozhao',
    category: 'poem',
    dynasty: 'weijin',
    title: '擬行路難·其四',
    source: '鮑照',
    description: '鮑照感嘆門閥制度下人才埋沒的悲憤詩篇。',
    content: '瀉水置平地，各自東西流。人生亦有命，安能行嘆復坐愁？酌酒以自寬，舉杯斷絕歌路難。心非木石豈無感？吞聲躑躅不敢言。',
  },

  {
    id: 'poem-hanjin-yuxin',
    category: 'poem',
    dynasty: 'weijin',
    title: '寄王琳',
    source: '庾信',
    description: '庾信羈留北方時思念江南故友的深情短詩。',
    content: '開君萬里書，獨下千行淚。恨別金陵遠，愁看玉關疏。眼看天下亂，日暮路途長。思為塞上雁，飛向稻花香。',
  },

  {
    id: 'poem-hanjin-luji',
    category: 'poem',
    dynasty: 'weijin',
    title: '猛虎行',
    source: '陸機',
    description: '陸機以「不飲盜泉水」自勉操守的古樂府詩。',
    content: '渴不飲盜泉水，熱不息惡木陰。惡木豈無陰，志士避禍侵。齊閔毀梁棟，重耳困覊旅。貞臣立嚴節，志士無險阻。',
  },

  {
    id: 'poem-hanjin-xielingyun',
    category: 'poem',
    dynasty: 'weijin',
    title: '登池上樓',
    source: '謝靈運',
    description: '山水詩鼻祖謝靈運名作，描寫自然景物細緻入微。',
    content: '潛虬媚幽姿，飛鴻響遠音。薄霄愧雲浮，棲川怍淵沉。進德智所拙，退耕力不任。徇祿及憂哀，企予悲人心。',
  },

  {
    id: 'poem-hanjin-yiming',
    category: 'poem',
    dynasty: 'weijin',
    title: '木蘭詩',
    source: '佚名',
    description: '北朝民歌代表作，歌頌代父從軍的木蘭。',
    content: '唧唧復唧唧，木蘭當戶織。不聞機杼聲，唯聞女嘆息。問女何所思，問女何所憶。女亦無所思，女亦無所憶。昨夜見軍帖，可汗大點兵，軍書十二卷，卷卷有爺名。阿爺無大兒，木蘭無長兄，願為市鞍馬，從此替爺征。',
  },

  {
    id: 'sutra-wangsheng-zhou',
    category: 'sutra',
    dynasty: 'weijin',
    title: '拔一切業障根本得生淨土陀羅尼',
    source: '劉宋·求那跋陀羅 譯',
    description: '淨土宗常用咒語，簡稱《往生咒》，能拔除一切業障。',
    content: '南無阿彌多婆夜。哆他伽多夜。哆地夜他。阿彌利都婆毗。阿彌利哆。悉耽婆毗。阿彌唎哆。毗迦蘭帝。阿彌唎哆。毗迦蘭多。伽彌膩。伽伽那。枳多迦利。娑婆訶。',
  },

  {
    id: 'calligraphy-wangxizhi-yueyi',
    category: 'calligraphy',
    dynasty: 'weijin',
    title: '王羲之·樂毅論',
    source: '王羲之',
    description: '王羲之小楷名篇，論述戰國名將樂毅的功績，結構平正，神采內斂。',
    content: '樂毅論。夏侯泰初。世人多以樂毅不時拔莒即墨為劣。是以敘而論之。夫求古賢之意。宜以大者遠者先之。必迂迴而難通然後已。焉可也。今樂氏之趣。或者其未盡乎。而多劣之。是使前賢失指於將來。不亦惜哉。',
  },

  {
    id: 'calligraphy-wangxizhi-huangting',
    category: 'calligraphy',
    dynasty: 'weijin',
    title: '王羲之·黃庭經',
    source: '王羲之',
    description: '王羲之著名小楷，又稱《換鵝帖》，道家經典。',
    content: '上有黃庭，下有關元。前有幽闕，後有命門。噓吸廬外，出入丹田。審能行之，可長存。黃庭中人衣朱衣，關門壯龠蓋兩扉。幽闕俠之高魏魏，丹田之中精氣微。玉池清水上生肥，靈根堅固志不衰。',
  },

  {
    id: 'calligraphy-wangxizhi-caoe',
    category: 'calligraphy',
    dynasty: 'weijin',
    title: '王羲之·曹娥碑',
    source: '王羲之',
    description: '紀念東漢孝女曹娥的碑文，小楷字體方整，法度嚴密。',
    content: '孝女曹娥者，上虞曹盱之女也。其先與周同祖，末胄荒沈，爰茲適居。盱能撫節按歌，婆娑樂神。漢安二年五月五日，迎伍君，逆濤而上，為水所淹，不得其屍。娥時年十四，號慕思盱，哀吟澤畔，旬有七日，遂自投江死，經五日，抱父屍出。',
  },

  {
    id: 'calligraphy-zhongyao-xuanshi',
    category: 'calligraphy',
    dynasty: 'weijin',
    title: '鍾繇·宣示表 (選段)',
    source: '鍾繇',
    description: '三國曹魏鍾繇所書小楷，字體寬扁，保留隸意，古雅樸茂，為小楷之祖。',
    content: '尚書宣示，孫權所求，詔令所報，所以博示。逮于卿佐，必冀良方，出於阿是。芻蕛之言，可擇廊廟。況繇始以疏賤，得為前恩，橫所盱睨，公私見異，愛同骨肉，殊遇厚寵，以至今日。再世榮名，同國休戚，敢不自量，竊致愚慮。',
  },

  {
    id: 'calligraphy-zhongyao-jianjizhi',
    category: 'calligraphy',
    dynasty: 'weijin',
    title: '鍾繇·薦季直表 (選段)',
    source: '鍾繇',
    description: '鍾繇向魏文帝曹丕推薦季直的奏表，筆法自然，古意盎然。',
    content: '臣繇言：臣自遭遇先帝，忝列腹心。爰自建安之初，王師破賊關東。時年荒榖貴，郡縣殘毀，三軍餽饟，朝不及夕。先帝神略奇計，委任得人。深山窮谷，民獻米豆，道路不絕。遂使強敵喪膽，我眾作氣。當時實用故山陽太守關內侯季直之策，尅期成事，不差豪髮。',
  },

  {
    id: 'calligraphy-weibei-zhangmenglong',
    category: 'calligraphy',
    dynasty: 'weijin',
    title: '北魏·張猛龍碑 (選段)',
    source: '張猛龍碑',
    description: '魏碑第一名帖，點劃剛健如刀砍斧鑿，結構奇險，動感極強。',
    content: '君諱猛龍，字神冏，南陽白水人也。其氏族分興，源流所出，故已備詳世錄，不復具載。蓊鬱於帝皇之始，德星曜像於朱鳥之間。淵玄萬壑之中，巉巖千峰之上。奕葉清高，煥乎篇牘矣。周宣時張仲，詩人詠其孝友，光緝姬周，中興是賴。',
  },

  {
    id: 'calligraphy-weibei-shipinggong',
    category: 'calligraphy',
    dynasty: 'weijin',
    title: '北魏·始平公造像記 (選段)',
    source: '始平公造像記',
    description: '龍門二十品之冠，唯一陽刻魏碑，字體極其雄強，筆劃方整粗重。',
    content: '夫靈蹤□啟。則攀宗靡尋。容像不陳。則崇之必□。是以真顏□於上齡。遺形敷於下葉。暨於大代。茲功厥作。比丘慧成。自以影濯玄流。邀逢昌運。率渴誠心。為國造石窟□。□系答皇恩。有資來業。父使持節光祿大夫洛州刺史始平公。奄焉薨放。',
  },

  {
    id: 'calligraphy-zhiyong-qianziwen',
    category: 'calligraphy',
    dynasty: 'weijin',
    title: '智永·真書千字文',
    source: '智永',
    description: '王羲之七世孫智永禪師所書，溫潤儒雅，法度精準，最適合真書入門。',
    content: '天地玄黃，宇宙洪荒。日月盈昃，辰宿列張。寒來暑往，秋收冬藏。閏餘成歲，律呂調陽。雲騰致雨，露結為霜。金生麗水，玉出崑岡。劍號巨闕，珠稱夜光。果珍李柰，菜重芥薑。海鹹河淡，鱗潛羽翔。龍師火帝，鳥官人皇。始制文字，乃服衣裳。推位讓國，有虞陶唐。弔民伐罪，周發殷湯。坐朝問道，垂拱平章。愛育黎首，臣伏戎羌。遐邇壹體，率賓歸王。鳴鳳在竹，白駒食場。化被草木，賴及萬方。蓋此身髮，四大五常。恭惟鞠養，豈敢毀傷。女慕貞潔，男效才良。知過必改，得能莫忘。罔談彼短，靡恃己長。信使可復，器欲難量。墨悲絲染，詩讚羔羊。景行維賢，克念作聖。德建名立，形端表正。空谷傳聲，虛堂習聽。禍因惡積，福緣善慶。尺璧非寶，寸陰是競。資父事君，曰嚴與敬。孝當竭力，忠則盡命。臨深履薄，夙興溫凊。似蘭斯馨，如松之盛。川流不息，淵澄取映。容止若思，言辭安定。篤初誠美，慎終宜令。榮業所基，籍甚無竟。學優登仕，攝職從政。存以甘棠，去而益詠。樂殊貴賤，禮別尊卑。上和下睦，夫唱婦隨。外受傅訓，入奉母儀。諸姑伯叔，猶子比兒。孔懷兄弟，同氣連枝。交友投分，切磨箴規。仁慈隱惻，造次弗離。節義廉退，顛沛匪虧。性靜情逸，心動神疲。守真志滿，逐物意移。堅持雅操，好爵自縻。都邑華夏，東西二京。背邙面洛，浮渭據涇。宮殿盤鬱，樓觀飛驚。圖寫禽獸，畫彩仙靈。丙舍傍啟，甲帳對楹。肆筵設席，鼓瑟吹笙。升階納陛，弁轉疑星。右通廣內，left達承明（應為左達承明）。既集墳典，亦聚群英。杜稿鐘隸，漆書壁經。府羅將相，路俠槐卿。戶封八縣，家給千兵。高冠陪輦，驅轂振纓。世祿侈富，車駕肥輕。策功茂實，勒碑刻銘。磻溪伊尹，佐時阿衡。奄宅曲阜，微旦孰營。桓公匡合，濟弱扶傾。綺回漢惠，說感武丁。俊乂密勿，多士寔寧。晉楚更霸，趙魏困橫。假途滅虢，踐土會盟。何遵約法，韓弊煩刑。起翦頗牧，用軍最精。宣威沙漠，馳譽丹青。九州禹跡，百郡秦併。嶽宗泰岱，禪主雲亭。雁門紫塞，雞田赤城。昆池碣石，鉅野洞庭。曠遠綿邈，岩岫杳冥。治本於農，務茲稼穡。俶載南畝，我藝黍稷。稅熟貢新，勸賞黜陟。孟軻敦素，史魚秉直。庶幾中庸，勞謙謹敕。聆音察理，鑒貌辨色。貽厥嘉猷，勉其祗植。省躬譏誡，寵增抗極。殆辱近恥，林皋幸即。兩疏見機，解組誰逼。索居閒處，沉默寂寥。求古尋論，散慮逍遙。欣奏累遣，戚謝歡招。渠荷的歷，園莽抽條。枇杷晚翠，梧桐蚤凋。陳根委翳，落葉飄搖。遊鶤獨運，凌摩絳霄。耽讀玩市，寓目囊箱。易輶攸畏，屬耳垣牆。具膳餐飯，適口充腸。飽飫烹宰，饑厭糟糠。親戚故舊，老少異糧。妾禦績紡，侍巾帷房。紈扇圓潔，銀燭煒煌。晝眠夕寐，藍筍象床。弦歌酒宴，接杯舉觴。矯手頓足，悅豫且康。嫡後嗣續，祭祀烝嘗。稽顙再拜，悚懼恐惶。箋牒簡要，顧答審詳。骸垢想浴，執熱願涼。驢騾犢特，駭躍超驤。誅斬賊盜，捕獲叛亡。布射僚丸，嵇琴阮嘯。恬筆倫紙，鈞巧任釣。釋紛利俗，並皆佳妙。毛施淑姿，工顰妍笑。年矢每催，曦暉朗曜。璇璣懸斡，晦魄環照。指薪修祜，永綏吉劭。矩步引領，俯仰廊廟。束帶矜莊，徘徊瞻眺。孤陋寡聞，愚蒙等誚。謂語助者，焉哉乎也。',
  },

  {
    id: 'calligraphy-luji-pingfu',
    category: 'calligraphy',
    dynasty: 'weijin',
    title: '陸機·平復帖 (全文)',
    source: '陸機',
    description: '現存最早的法書真跡，西晉陸機章草佳作，筆意古拙，墨氣淋漓。',
    content: '彥先羸瘵，恐難平復。往治疾，未能相見。克前至，當自問訊。陸機以章草寫信問候友人疾病，字體奇古，含蓄樸拙，為書法史之無上至寶。',
  },

  {
    id: 'calligraphy-wangxianzhi-shisanhang',
    category: 'calligraphy',
    dynasty: 'weijin',
    title: '王獻之·洛神賦十三行',
    source: '王獻之',
    description: '王獻之小楷巔峰之作，字體靈動挺拔，筆劃展放，神采外耀。',
    content: '熙事備，嘉娛始。吸飛泉之神液，漱玉池之芳醴。於是背下陵高，足往神留。遺情想像，顧望懷愁。步踟躕於山隅，忽蓬轉而無所。王獻之書洛神賦小楷，結體寬綽，行筆秀逸，開創了小楷靈動挺拔之新風氣。',
  },
  {
    id: 'sutra-jingang-ex-1',
    category: 'sutra',
    dynasty: 'weijin',
    title: '金剛經·核心精華 (上)·發心離相篇',
    source: '姚秦·鳩摩羅什 譯',
    description: '收錄金剛經第一分、第二分及第六分，包含法會因由、須菩提啟請安住其心、持戒修福無住生信及「知我說法如筏喻者，法尚應捨何況非法」。',
    content: '如是我聞。一時佛在舍衛國祇樹給孤獨園，與大比丘眾千二百五十人俱。爾時世尊食時，著衣持缽，入舍衛大城乞食。於其城中次第乞已，還至本處。飯食訖，收衣缽，洗足已，敷座而坐。\n\n時長老須菩提在大眾中，即從座起，偏袒右肩，右膝著地，合掌恭敬而白佛言：希有世尊。如來善護念諸菩薩，善付囑諸菩薩。世尊，善男子善女人，發阿耨多羅三藐三菩提心，云何應住，云何降伏其心。佛言：善哉善哉。須菩提，如汝所說，如來善護念諸菩薩，善付囑諸菩薩。汝今諦聽，當為汝說。善男子善女人，發阿耨多羅三藐三菩提心，應如是住，如是降伏其心。唯然世尊，願樂欲聞。\n\n須菩提白佛言：世尊，頗有眾生，得聞如是言說章句，生實信不。佛告須菩提：莫作是說。如來滅後，後五百歲，有持戒修福者，於此章句能生信心，以此為實。當知是人不於一佛二佛三四五佛而植善根，已於無量千萬佛所植諸善根。聞是章句，乃至一念生淨信者。須菩提，如來悉知悉見，是諸眾生得如是無量福德。何以故。是諸眾生無復我相人相眾生相壽者相。無法相，亦無非法相。何以故。是諸眾生若心取相，則為著我人眾生壽者。若取法相，即著我人眾生壽者。是故不應取法，不應取非法。以是義故，如來常說：汝等比丘，知我說法，如筏喻者，法尚應捨，何況非法。',
  },

  {
    id: 'sutra-jingang-ex-2',
    category: 'sutra',
    dynasty: 'weijin',
    title: '金剛經·核心精華 (下)·無相寂滅篇',
    source: '姚秦·鳩摩羅什 譯',
    description: '收錄金剛經第十四分、第十八分及第三十二分，包含離一切諸相即名諸佛、過去心現在心未來心不可得，以及著名的六喻四句偈「一切有為法，如夢幻泡影」。',
    content: '爾時須菩提聞說是經，深解義趣，涕淚悲泣，而白佛言：希有世尊。佛說如是甚深經典，我從昔來所得慧眼，未曾得聞如是之經。世尊，若復有人得聞是經，信心清淨，則生實相，當知是人，成就第一希有功德。世尊，是實相者，則是非相，是故如來說名實相。世尊，我今得聞如是經典，信解受持不足為難，若當來世，後五百歲，其有眾生，得聞是經，信解受持，是人則為第一希有。何以故。此人無我相，無人相，無眾生相，無壽者相。所以者何。我相即是非相，人相眾生相壽者相即是非相。何以故。離一切諸相，則名諸佛。佛告須菩提：如是如是。若復有人，得聞是經，不驚不怖不畏，當知是人甚為希有。何以故。須菩提，如來說第一波羅蜜，即非第一波羅蜜，是名第一波羅蜜。\n\n須菩提，於意云何，如來有肉眼不。如是世尊，如來有肉眼。須菩提，於意云何，如來有天眼不。如是世尊，如來有天眼。須菩提，於意云何，如來有慧眼不。如是世尊，如來有慧眼。須菩提，於意云何，如來有法眼不。如是世尊，如來有法眼。須菩提，於意云何，如來有佛眼不。如是世尊，如來有佛眼。須菩提，於意云何，如恒河中所有沙，佛說是沙不。如是世尊，如來說是沙。須菩提，於意云何，如一恒河中所有沙，有如是沙等恒河，是諸恒河所有沙數佛世界，如是寧為多不。甚多世尊。佛告須菩提：爾所國土中，所有眾生若干種心，如來悉知。何以故。如來說諸心皆為非心，是名為心。所以者何。須菩提，過去心不可得，現在心不可得，未來心不可得。\n\n云何為人演說，不取於相，如如不動。何以故。一切有為法，如夢幻泡影，如露亦如電，應作如是觀。佛說是經已，長老須菩提及諸比丘、比丘尼、優婆塞、優婆夷，一切世間天人阿修羅，聞佛所說，皆大歡喜，信受奉行。',
  },

  {
    id: 'sutra-pumenpin-ji',
    category: 'sutra',
    dynasty: 'weijin',
    title: '觀世音菩薩普門品偈頌 (三十偈全品)',
    source: '姚秦·鳩摩羅什 譯',
    description: '妙法蓮華經觀世音菩薩普門品之三十首五言重頌全文，讚頌觀音大士千處祈求千處應、苦海常作度人舟之宏深誓願。',
    content: '世尊妙相具，我今重問彼，佛子何因緣，名為觀世音。\n具足妙相尊，偈答無盡意：汝聽觀音行，善應諸方所，弘誓深如海，歷劫不思議，侍多千億佛，發大清淨願。我為汝略說，聞名及見身，心念不空過，能滅諸有苦。\n假使興害意，推落大火坑，念彼觀音力，火坑變成池。或漂流巨海，龍魚諸鬼難，念彼觀音力，波浪不能沒。或在須彌峰，為人所推墮，念彼觀音力，如日虛空住。或被惡人逐，墮落金剛山，念彼觀音力，不能損一毛。或值怨賊繞，各執刀加害，念彼觀音力，咸即起慈心。或遭王難苦，臨刑欲壽終，念彼觀音力，刀尋段段壞。或囚禁枷鎖，手足被杻械，念彼觀音力，釋然得解脫。\n咒詛諸毒藥，所欲害身者，念彼觀音力，還著於本人。或遇惡羅剎，毒龍諸鬼等，念彼觀音力，時悉不敢害。若惡獸圍繞，利牙爪可怖，念彼觀音力，疾走無邊方。蚖蛇及蝮蠍，氣毒煙火然，念彼觀音力，尋聲自回去。雲雷鼓掣電，降雹澍大雨，念彼觀音力，應時得消散。\n眾生被困厄，無量苦逼身，觀音妙智力，能救世間苦。具足神通力，廣修智方便，十方諸國土，無剎不現身。種種諸惡趣，地獄鬼畜生，生老病死苦，以漸悉令滅。\n真觀清淨觀，廣大智慧觀，梵音海潮音，勝彼世間音，是故須常念，念念勿生疑。觀世音淨聖，於苦惱死厄，能為作依怙，具一切功德，慈眼視眾生，福聚海無量，是故應頂禮。',
  },

  {
    id: 'sutra-amituo-1',
    category: 'sutra',
    dynasty: 'weijin',
    title: '佛說阿彌陀經·其一·極樂莊嚴篇',
    source: '姚秦·鳩摩羅什 譯',
    description: '阿彌陀經第一篇，記述舍衛國法會因由，詳細開示西方極樂國土之名由、七重欄楯、七寶池、八功德水與天樂雨華之殊勝依報莊嚴。',
    content: '如是我聞。一時，佛在舍衛國祇樹給孤獨園，與大比丘僧千二百五十人俱，皆是大阿羅漢，眾所知識：長老舍利弗、摩訶目犍連、摩訶迦葉、摩訶迦旃延、摩訶俱絺羅、離婆多、周利槃陀伽、難陀、阿難陀、羅睺羅、憍梵波提、賓頭盧頗羅墮、迦留陀夷、摩訶劫賓那、薄拘羅、阿那樓馱，如是等諸大弟子。并諸菩薩摩訶薩：文殊師利法王子、阿逸多菩薩、乾陀訶提菩薩、常精進菩薩，與如是等諸大菩薩，及釋提桓因等，無量諸天大眾俱。\n爾時，佛告長老舍利弗：「從是西方，過十萬億佛土，有世界名曰極樂，其土有佛，號阿彌陀，今現在說法。\n舍利弗，彼土何故名為極樂？其國眾生，無有眾苦，但受諸樂，故名極樂。\n又舍利弗。極樂國土，七重欄楯，七重羅網，七重行樹，皆是四寶周匝圍繞，是故彼國名為極樂。\n又舍利弗。極樂國土，有七寶池，八功德水，充滿其中，池底純以金沙布地。四邊階道，金、銀、琉璃、玻璃合成。上有樓閣，亦以金、銀、琉璃、玻璃、硨磲、赤珠、瑪瑙而嚴飾之。池中蓮花大如車輪，青色青光、黃色黃光、赤色赤光、白色白光，微妙香潔。舍利弗。極樂國土，成就如是功德莊嚴。\n又舍利弗。彼佛國土，常作天樂。黃金為地。晝夜六時，雨天曼陀羅華。其土眾生，常以清旦，各以衣祴盛眾妙華，供養他方十萬億佛，即以食時，還到本國，飯食經行。舍利弗。極樂國土，成就如是功德莊嚴。',
  },

  {
    id: 'sutra-amituo-2',
    category: 'sutra',
    dynasty: 'weijin',
    title: '佛說阿彌陀經·其二·持名往生篇',
    source: '姚秦·鳩摩羅什 譯',
    description: '阿彌陀經第二篇，開示眾鳥說法、無量光壽佛號由來、一生補處諸上善人，以及「若一日若七日執持名號一心不亂」臨終必蒙接引之念佛法門。',
    content: '復次舍利弗：彼國常有種種奇妙雜色之鳥：白鶴、孔雀、鸚鵡、舍利、迦陵頻伽、共命之鳥。是諸眾鳥，晝夜六時，出和雅音。其音演暢五根、五力、七菩提分、八聖道分，如是等法。其土眾生，聞是音已，皆悉念佛、念法、念僧。舍利弗。汝勿謂此鳥，實是罪報所生，所以者何？彼佛國土，無三惡道。舍利弗。其佛國土，尚無惡道之名，何況有實。是諸眾鳥，皆是阿彌陀佛，欲令法音宣流，變化所作。\n舍利弗。彼佛國土，微風吹動諸寶行樹，及寶羅網，出微妙音，譬如百千種樂，同時俱作。聞是音者，自然皆生念佛、念法、念僧之心。舍利弗。其佛國土，成就如是功德莊嚴。\n舍利弗。於汝意云何？彼佛何故號阿彌陀？舍利弗。彼佛光明無量，照十方國，無所障礙，是故號為阿彌陀。又舍利弗。彼佛壽命，及其人民，無量無邊阿僧祇劫，故名阿彌陀。舍利弗。阿彌陀佛成佛已來，於今十劫。又舍利弗。彼佛有無量無邊聲聞弟子，皆阿羅漢，非是算數之所能知。諸菩薩眾，亦復如是。舍利弗。彼佛國土，成就如是功德莊嚴。\n又舍利弗。極樂國土，眾生生者，皆是阿鞞跋致，其中多有一生補處，其數甚多，非是算數所能知之，但可以無量無邊阿僧祇說。舍利弗。眾生聞者，應當發願，願生彼國。所以者何？得與如是諸上善人，俱會一處。舍利弗。不可以少善根福德因緣，得生彼國。\n舍利弗。若有善男子善女人，聞說阿彌陀佛，執持名號，若一日、若二日、若三日、若四日、若五日、若六日、若七日，一心不亂。其人臨命終時，阿彌陀佛，與諸聖眾，現在其前。是人終時，心不顛倒，即得往生阿彌陀佛極樂國土。舍利弗。我見是利，故說此言。若有眾生，聞是說者，應當發願，生彼國土。',
  },

  {
    id: 'sutra-amituo-3',
    category: 'sutra',
    dynasty: 'weijin',
    title: '佛說阿彌陀經·其三·諸佛護念篇',
    source: '姚秦·鳩摩羅什 譯',
    description: '阿彌陀經第三篇，開示六方恆河沙數諸佛同出廣長舌相稱讚不可思議功德，證明念佛發願必得不退轉之殊勝利益。',
    content: '舍利弗。如我今者，稱讚阿彌陀佛，不可思議功德之利。東方亦有阿閦鞞佛、須彌相佛、大須彌佛、須彌光佛、妙音佛，如是等恆河沙數諸佛，各於其國，出廣長舌相，遍覆三千大千世界，說誠實言：『汝等眾生，當信是稱讚不可思議功德，一切諸佛所護念經。』\n舍利弗。南方世界，有日月燈佛、名聞光佛、大燄肩佛、須彌燈佛、無量精進佛，如是等恆河沙數諸佛，各於其國，出廣長舌相，遍覆三千大千世界，說誠實言：『汝等眾生，當信是稱讚不可思議功德，一切諸佛所護念經。』\n舍利弗。西方世界，有無量壽佛、無量相佛、無量幢佛、大光佛、大明佛、寶相佛、淨光佛；北方世界，有燄肩佛、最勝音佛、難沮佛、日生佛、網明佛；下方世界，有師子佛、名聞佛、名光佛、達摩佛、法幢佛、持法佛；上方世界，有梵音佛、宿王佛、香上佛、香光佛、大燄肩佛、雜色寶華嚴身佛、娑羅樹王佛、寶華德佛、見一切義佛、如須彌山佛，如是等恆河沙數諸佛，各於其國，出廣長舌相，遍覆三千大千世界，說誠實言：『汝等眾生，當信是稱讚不可思議功德，一切諸佛所護念經。』\n舍利弗。若有人，已發願、今發願、當發願，欲生阿彌陀佛國者，是諸人等，皆得不退轉於阿耨多羅三藐三菩提。是故舍利弗，諸善男子、善女人，若有信者，應當發願生彼國土。\n舍利弗。如我今者，稱讚諸佛不可思議功德，彼諸佛等，亦稱讚我不可思議功德，而作是言：『釋迦牟尼佛，能為甚難希有之事，能於娑婆國土，五濁惡世，得阿耨多羅三藐三菩提，為諸眾生，說是一切世間難信之法。』\n佛說此經已，舍利弗及諸比丘，一切世間天、人、阿修羅等，聞佛所說，歡喜信受，作禮而去。',
  },

  {
    id: 'sutra-guanwuliangshou-sanyu',
    category: 'sutra',
    dynasty: 'weijin',
    title: '佛說觀無量壽佛經·淨業三福 (全文)',
    source: '劉宋·畺良耶舍 譯',
    description: '觀無量壽經中著名的「淨業三福」，為一切欲往生西方極樂世界行者之正因。',
    content: '欲生彼國者，當修三福：一者、孝養父母，奉事師長，慈心不殺，修十善業。二者、受持三歸，具足眾戒，不犯威儀。三者、發菩提心，深信因果，讀誦大乘，勸進行者。如此三事，名為淨業。佛告韋提希：汝今知不，此三種業，乃是三世諸佛，淨業正因。',
  },

  {
    id: 'sutra-yijiao-1',
    category: 'sutra',
    dynasty: 'weijin',
    title: '佛遺教經·其一·持戒清淨篇',
    source: '姚秦·鳩摩羅什 譯',
    description: '佛陀臨涅槃前最後教誨第一篇，開示以戒為師（波羅提木叉）、持戒清淨與制伏五根心猿意馬之第一要門。',
    content: '釋迦牟尼佛，初轉法輪，度阿若憍陳如；最後說法，度須跋陀羅。所應度者，皆已度訖。於娑羅雙樹間，將入涅槃。是時中夜，寂然無聲，為諸弟子略說法要。\n汝等比丘，於我滅後，當尊重珍敬波羅提木叉，如闇遇明，貧人得寶。當知此則是汝等大師，若我住世，無異此也。持淨戒者，不得販賣貿易，安置田宅，畜養人民、奴婢、畜生；一切種植及諸財寶，皆當遠離，如避火阬；不得斬伐草木，墾土掘地。合和湯藥，占相吉凶，仰觀星宿，推步盈虛，歷數算計，皆所不應。節身時食，清淨自活，不得參預世事、通致使命，咒術仙藥，結好貴人，親厚媟慢，皆不應作。當自端心，正念求度；不得包藏瑕疵，顯異惑眾；於四供養，知量知足，趣得供事，不應畜積。此則略說持戒之相。\n戒是正順解脫之本，故名波羅提木叉。因依此戒，得生諸禪定，及滅苦智慧。是故比丘，當持淨戒，勿令毀缺。若能持淨戒，是則能有善法；若無淨戒，諸善功德皆不得生。是以當知，戒為第一安隱功德住處。\n汝等比丘，已能住戒，當制五根，勿令放逸，入於五欲。譬如牧牛之人，執杖視之，不令縱逸，犯人苗稼。若縱五根，非唯五欲將無涯畔，不可制也；亦如惡馬，不以轡制，將當牽人墬於阬埳。如被劫賊，苦止一世；五根賊禍，殃及累世。為害甚重，不可不慎！是故智者制而不隨，持之如賊，不令縱逸；假令縱之，皆亦不久見其磨滅。此五根者，心為其主，是故汝等當好制心。心之可畏，甚於毒蛇、惡獸、怨賊、大火越逸，未足喻也。譬如有人，手執蜜器，動轉輕躁，但觀於蜜，不見深阬。譬如狂象無鉤，猿猴得樹，騰躍踔躑，難可禁制。當急挫之，無令放逸。縱此心者，喪人善事；制之一處，無事不辦。是故比丘，當勤精進，折伏汝心。',
  },

  {
    id: 'sutra-yijiao-2',
    category: 'sutra',
    dynasty: 'weijin',
    title: '佛遺教經·其二·端心正念篇',
    source: '姚秦·鳩摩羅什 譯',
    description: '佛陀臨涅槃前最後教誨第二篇，開示受食如服藥、無以睡眠空過一生、慚恥為第一莊嚴，以及忍辱除瞋、不壞善法之德。',
    content: '汝等比丘，受諸飲食，當如服藥，於好於惡，勿生增減。趣得支身，以除饑渴。如蜂採華，但取其味，不損色香；比丘亦爾，受人供養，趣自除惱，無得多求，壞其善心。譬如智者，籌量牛力所堪多少，不令過分，以竭其力。\n汝等比丘，晝則勤心修習善法，無令失時；初夜後夜，亦勿有廢。中夜誦經，以自消息，無以睡眠因緣，令一生空過，無所得也。當念無常之火，燒諸世間，早求自度，勿睡眠也。諸煩惱賊常伺殺人，甚於怨家，安可睡眠，不自警寤？煩惱毒蛇睡在汝心，譬如黑蚖在汝室睡，當以持戒之鉤早摒除之。睡蛇既出，乃可安眠；不出而眠，是無慚人！慚恥之服，於諸莊嚴，最為第一。慚如鐵鉤，能制人非法，是故常當慚恥，無得暫替。若離慚恥，則失諸功德。有愧之人，則有善法；若無愧者，與諸禽獸無相異也。\n汝等比丘！若有人來節節支解，當自攝心，無令瞋恨；亦當護口，勿出惡言。若縱恚心，即自妨道，失功德利。忍之為德，持戒苦行，所不能及。能行忍者，乃可名為有力大人。若其不能歡喜忍受惡罵之毒，如飲甘露者，不名入道智慧人也。所以者何，瞋恚之害，則破諸善法，壞好名聞，今世後世，人不喜見。當知瞋心，甚於猛火，常當防護，無令得入。劫功德賊，無過瞋恚。白衣受欲，非行道人，無法自制，瞋猶可恕；出家行道，乃至於欲，而懷瞋恚，譬如清冷雲中，而生霹靂，起火燒空，非所應也。',
  },

  {
    id: 'sutra-yijiao-3',
    category: 'sutra',
    dynasty: 'weijin',
    title: '佛遺教經·其三·精進寂滅篇',
    source: '姚秦·鳩摩羅什 譯',
    description: '佛陀臨涅槃前最後教誨第三篇，開示去憍慢諂曲、少欲知足、精進如小水穿石，以及世間無常敗壞、勤求出道之最後囑咐。',
    content: '汝等比丘，當自摩頭，已捨飾好，著壞色衣，執持應器，以乞自活。自見如是，若起憍慢，當疾滅之。增長憍慢，尚非世俗白衣所宜，何況出家入道之人，為解脫故，自降其身，而行乞法？\n汝等比丘，諂曲之心，與道相違，是故宜應質直其心。當知諂曲，但為欺誑，入道之人，則無是處。是故汝等，宜當端心，以質直為本。\n汝等比丘，當知多欲之人，多求利故，苦惱亦多；少欲之人，無求無欲，則無此患。直爾少欲，尚應修習，何況少欲能生諸善功德？少欲之人，則無諂曲以求人意，亦復不為諸根所牽。行少欲者，心則坦然，無所憂畏，觸事有餘，常無不足。有少欲者，則有涅槃，是名少欲。\n汝等比丘，若欲脫諸苦惱，當觀知足。知足之法，即是富樂安隱之處。知足之人，雖臥地上，猶為安樂；不知足者，雖處天堂，亦不稱意。不知足者，雖富而貧；知足之人，雖貧而富。不知足者，常為五欲所牽，為知足者之所憐愍，是名知足。\n汝等比丘，若勤修精進，則事無難者，是故汝等，當勤精進。譬如小水長流，則能穿石。實智慧者，則是度老病死海，堅牢船也；亦是無明黑闇大明燈也；亦是一切病者之良藥也；亦是伐煩惱樹之利斧也。\n汝等比丘，常當一心，勤求出道。一切世間，動不動法，皆是敗壞不安之相。汝等且止，勿復喧說，將欲滅度，是我最後之所教誨。',
  },

  {
    id: 'sutra-yulanpen-ex',
    category: 'sutra',
    dynasty: 'weijin',
    title: '佛說盂蘭盆經',
    source: '西晉·竺法護 譯',
    description: '記述目犍連尊者救母的故事，闡明佛教孝道與在七月十五日設盆供僧以報父母深恩之法。',
    content: '聞如是：一時，佛在舍衛國祇樹給孤獨園。大目犍連始得六通，欲度父母，報乳哺之恩。即以道眼觀視世間，見其亡母生餓鬼中，不見飲食，皮骨連立。目連悲哀，即以缽盛飯，往餉其母。母得缽飯，便以左手障缽，右手摶食，食未入口，化成火炭，遂不得食。目連大叫，悲號涕泣，馳還白佛，具陳如此。\n佛言：「汝母罪根深結，非汝一人力所奈何！汝雖孝順，聲動天地、天神、地祇、邪魔、外道、道士、四天王神，亦不能奈何！當須十方眾僧威神之力乃得解脫。吾今當為汝說救濟之法，令一切難皆離憂苦，罪障消除。」\n佛告目連：「十方眾僧於七月十五日，僧自恣時，當為七世父母及現在父母厄難中者，具飯、百味五果、汲灌盆器、香油錠燭、床敷臥具，盡世甘美以著盆中，供養十方大德眾僧。當此之日，一切聖眾，或在山間禪定、或得四道果、或在樹下經行；或六通自在、教化聲聞、緣覺；或十地菩薩大人權現比丘，在大眾中；皆同一心，受缽和羅飯。具清淨戒聖眾之道，其德汪洋，其有供養此等自恣僧者，現在父母、七世父母、六種親屬得出三塗之苦，應時解脫，衣食自然。若復有人父母現在者，福樂百年；若已亡七世父母，生天，自在化生，入天華光，受無量快樂。」\n時佛勅十方眾僧，皆先為施主家咒願，願七世父母行禪定意，然後受食。初受食時，先安在佛前，塔寺中佛前，眾僧咒願竟，便自受食。\n時目連比丘及大菩薩眾皆大歡喜，目連悲啼泣聲，釋然除滅。時目連母即於是日，得脫一劫餓鬼之苦。\n目連復白佛言：「弟子所生母，得蒙三寶功德之力，眾僧威神力故。若未來世，一切佛弟子，亦應奉盂蘭盆，救度現在父母，乃至七世父母，可為爾否？」\n佛言：「大善快問！我正欲說，汝今復問。善男子！若比丘、比丘尼、國王、太子、大臣、宰相、三公、百官、萬民、庶人，行慈孝者，皆應先為所生現在父母、過去七世父母，於七月十五日，佛歡喜日，僧自恣日，以百味飯食，安盂蘭盆中，施十方自恣僧，願使現在父母，壽命百年無病、無一切苦惱之患，乃至七世父母離惡鬼苦，生人天中，福樂無極。是佛弟子修孝順者，應念念中，常憶父母，乃至七世父母。年年七月十五日，常以孝慈，憶所生父母，為作盂蘭盆，施佛及僧，以報父母長養慈愛之恩。若一切佛弟子，應當奉持是法。」\n時目連比丘、四輩弟子，歡喜奉行。',
  },

  {
    id: 'sutra-damo-poxiang',
    category: 'sutra',
    dynasty: 'weijin',
    title: '達摩祖師破相論 (觀心章全文)',
    source: '梁·菩提達摩 著',
    description: '達摩祖師關於「觀心一法，總攝諸法」的禪宗妙諦節選。',
    content: '問曰：若復有人志求佛道者，當修何法，最為省要？答曰：唯觀心一法，總攝諸法，最為省要。問曰：何一法能攝諸法？答曰：心者萬法之根本，一切諸法唯心所生；若能了心，則萬法具備。譬如大樹，所有枝葉及諸花果，皆悉依根。立樹但從根剪，理當自活；若不從根，徒費其力。故知一切善惡皆由自心，心外別求，終無是處。',
  },

  {
    id: 'sutra-baiyu-parables',
    category: 'sutra',
    dynasty: 'weijin',
    title: '百喻經·寓言兩則 (選粹)',
    source: '蕭齊·求那毗地 譯',
    description: '節選百喻經中「愚人食鹽」與「愚人建三層樓」兩則著名的佛教寓言，諷喻世人做事不切實際、本末倒置。',
    content: '愚人食鹽喻：昔有愚人，往鄰家客。主人設食，嫌淡無味。主人聞已，即為加鹽。愚人食之，甚覺美味。心自思惟：食之所以美者，緣有鹽故。少許尚爾，況多食之。愚人遂空口食鹽，味苦反敗。愚人建三層樓喻：往昔有富人，愚無所知。見他人造三層樓，高廣華麗，心生羨慕。即召工匠曰：為我建三層樓。工匠開始掘地基，造磚。富人見之問曰：建何等屋。工匠答言：造三層樓。富人言：我不要下兩層，汝可為我直造第三層。工匠答言：無有是處。無下兩層，何以建第三層。',
  },

  {
    id: 'poem-weijin-dengloufu',
    category: 'poem',
    dynasty: 'weijin',
    title: '登樓賦',
    source: '王粲',
    description: '「台灣高中」學段建安文學名作，王粲登樓抒寫思鄉懷土與懷才不遇的憂思。',
    content: '登茲樓以四望兮，聊暇日以銷憂。覽斯宇之所處兮，實顯敞而寡仇。挾清漳之通浦兮，倚曲沮之長洲。背墳衍之廣陸兮，臨皋隰之沃流。北彌陶牧，西接昭丘。華實蔽野，黍稷盈疇。雖信美而非吾土兮，曾何足以少留！遭紛濁而遷逝兮，漫踰紀以迄今。情眷眷而懷歸兮，孰憂思之可任？憑軒檻以遙望兮，向北風而開襟。平原遠而極目兮，蔽荊山之高岑。路逶迤而修迥兮，川既漾而濟深。悲舊鄉之壅隔兮，涕橫墜而弗禁。昔尼父之在陳兮，有「歸與」之嘆音。鍾儀幽而楚奏兮，莊舄顯而越吟。人情同於懷土兮，豈窮達而異心？惟日月之逾邁兮，俟河清其未極。冀王道之一平兮，假高衢而騁力。懼匏瓜之徒懸兮，畏井渫之莫食。步棲遲以徙倚兮，白日忽其將匿。風蕭瑟而並興兮，天慘慘而無色。獸狂顧以求羣兮，鳥相鳴而舉翼。原野闃其無人兮，征夫行而未息。心悽愴以感發兮，意忉怛而悯惻。循階除而下降兮，氣交憤於胸臆。夜參半而不寐兮，悵盤桓以反側。',
  },
  {
    id: 'classic-weijin-yuchenbozhi',
    category: 'poem',
    dynasty: 'weijin',
    title: '與陳伯之書',
    source: '丘遲',
    description: '「台灣高中」學段經典駢文，丘遲以情動人、以理服人，成功勸降陳伯之的書信名篇。',
    content: '遲頓首，陳將軍足下：無恙，幸甚，幸甚！將軍勇冠三軍，才為世出，棄燕雀之小志，慕鴻鵠以高翔。昔因機變化，遭遇明主；立功立事，開國稱孤；朱輪華轂，擁旄萬里，何其壯也！如何一旦為奔亡之虜，聞鳴鏑而股戰，對穹廬以屈膝，又何劣邪！尋君去就之際，非有他故，直以不能內審諸己，外受流言，沉迷猖獗，以至於此。聖朝赦罪責功，棄瑕錄用，推赤心於天下，安反側於萬物；將軍之所知，不假僕一二談也。朱鮪涉血於友于，張繡剚刃於愛子，漢主不以為疑，魏君待之若舊。況將軍無昔人之罪，而勳重於當世。夫迷途知返，往哲是與；不遠而復，先典攸高。主上屈法申恩，吞舟是漏；將軍松柏不翦，親戚安居，高臺未傾，愛妾尚在，悠悠爾心，亦何可言！今功臣名將，雁行有序，佩紫懷黃，贊帷幄之謀；乘軺建節，奉疆埸之任。並刑馬作誓，傳之子孫。將軍獨靦顏借命，驅馳氈裘之長，寧不哀哉！夫以慕容超之強，身送東市；姚泓之盛，面縛西都。故知霜露所均，不育異類；姬漢舊邦，無取雜種。北虜僭盜中原，多歷年所，惡積禍盈，理至燋爛。況偽孽昏狡，自相夷戮；部落攜離，酋豪猜貳。方當繫頸蠻邸，懸首藁街，而將軍魚游於沸鼎之中，燕巢於飛幕之上，不亦惑乎！暮春三月，江南草長，雜花生樹，群鶯亂飛。見故國之旗鼓，感平生於疇日，撫弦登陴，豈不愴悢！所以廉公之思趙將，吳子之泣西河，人之情也。將軍獨無情哉？想早勵良規，自求多福。當今皇帝盛明，天下安樂。白環西獻，楛矢東來；夜郎、滇池，解辮請職；朝鮮、昌海，蹶角受化。唯北狄野心，掘強沙塞之間，欲延歲月之命耳。中軍臨川殿下，明德茂親，總茲戎重，弔民洛汭，伐罪秦中。若遂不改，方思僕言。聊布往懷，君其詳之。丘遲頓首。',
  },
  {
    id: 'poem-weijin-yinjiuershishou',
    category: 'poem',
    dynasty: 'weijin',
    title: '飲酒二十首',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '【其一】\n衰榮無定在，彼此更共之。\n邵生瓜田中，寧似東陵時！\n寒暑有代謝，人道每如茲。\n達人解其會，逝將不復疑；\n忽與一觴酒，日夕歡相持。\n【其二】\n積善雲有報，夷叔在西山。\n善惡苟不應，何事空立言！\n九十行帶索，飢寒況當年。\n不賴固窮節，百世當誰傳。\n【其三】\n道喪向千載，人人惜其情。\n有酒不肯飲，但顧世間名。\n所以貴我身，豈不在一生？\n一生復能幾，倏如流電驚。\n鼎鼎百年內，持此欲何成！\n【其四】\n棲棲失羣鳥，日暮猶獨飛。\n徘徊無定止，夜夜聲轉悲。\n厲響思清遠，去來何依依。\n因值孤生松，斂翮遙來歸。\n勁風無榮木，此蔭獨不衰。\n託身已得所，千載不相違。\n【其五】\n結廬在人境，而無車馬喧。\n問君何能爾？心遠地自偏。\n採菊東籬下，悠然見南山。\n山氣日夕佳，飛鳥相與還。\n此中有真意，欲辨已忘言。\n【其六】\n行止千萬端，誰知非與是。\n是非苟相形，雷同共譽毀。\n三季多此事，達士似不爾。\n咄咄俗中愚，且當從黃綺。\n【其七】\n秋菊有佳色，裛露掇其英。\n泛此忘憂物，遠我遺世情。\n一觴雖獨進，杯盡壺自傾。\n日入羣動息，歸鳥趨林鳴。\n嘯傲東軒下，聊復得此生。\n【其八】\n青松在東園，衆草沒其姿。\n凝霜殄異類，卓然見高枝。\n連林人不覺，獨樹衆乃奇。\n提壺撫寒柯，遠望時復爲。\n吾生夢幻間，何事紲塵羈。\n【其九】\n清晨聞叩門，倒裳往自開。\n問子爲誰歟？田父有好懷。\n壺漿遠見候，疑我與時乖。\n襤縷茅檐下，未足爲高棲。\n一世皆尚同，願君汩其泥。\n深感父老言，稟氣寡所諧。\n紆轡誠可學，違己詎非迷。\n且共歡此飲，吾駕不可回。\n【其十】\n在昔曾遠遊，直至東海隅。\n道路迥且長，風波阻中塗。\n此行誰使然？似爲飢所驅。\n傾身營一飽，少許便有餘。\n恐此非名計，息駕歸閒居。\n【其十一】\n顏生稱爲仁，榮公言有道。\n屢空不獲年，長飢至於老。\n雖留身後名，一生亦枯槁。\n死去何所知，稱心固爲好。\n客養千金軀，臨化消其寶。\n裸葬何必惡，人當解意表。\n【其十二】\n長公曾一仕，壯節忽失時；\n杜門不復出，終身與世辭。\n仲理歸大澤，高風始在茲。\n一往便當已，何爲復狐疑！\n去去當奚道，世俗久相欺。\n擺落悠悠談，請從餘所之。\n【其十三】\n有客常同止，取捨邈異境。\n一士常獨醉，一夫終年醒。\n醒醉還相笑，發言各不領。\n規規一何愚，兀傲差若穎。\n寄言酣中客，日沒燭當秉。\n【其十四】\n故人賞我趣，挈壺相與至。\n班荊坐松下，數斟已復醉。\n父老雜亂言，觴酌失行次。\n不覺知有我，安知物爲貴？\n悠悠迷所留，酒中有深味。\n【其十五】\n貧居乏人工，灌木荒餘宅。\n班班有翔鳥，寂寂無行跡。\n宇宙一何悠，人生少至百。\n歲月相催逼，鬢邊早已白。\n若不委窮達，素抱深可惜。\n【其十六】\n少年罕人事，遊好在六經。\n行行向不惑，淹留遂無成。\n竟抱固窮節，飢寒飽所更。\n敝廬交悲風，荒草沒前庭。\n披褐守長夜，晨雞不肯鳴。\n孟公不在茲，終以翳吾情。\n【其十七】\n幽蘭生前庭，含薰待清風。\n清風脫然至，見別蕭艾中。\n行行失故路，任道或能通。\n覺悟當念遷，鳥盡廢良弓。\n【其十八】\n子云性嗜酒，家貧無由得。\n時賴好事人，載醪祛所惑。\n觴來爲之盡，是諮無不塞。\n有時不肯言，豈不在伐國。\n仁者用其心，何嘗失顯默。\n【其十九】\n疇昔苦長飢，投耒去學仕。\n將養不得節，凍餒固纏己。\n是時向立年，志意多所恥。\n遂盡介然分，拂衣歸田裏。\n冉冉星氣流，亭亭復一紀。\n世路廓悠悠，楊朱所以止。\n雖無揮金事，濁酒聊可恃。\n【其二十】\n羲農去我久，舉世少復真。\n汲汲魯中叟，彌縫使其淳。\n鳳鳥雖不至，禮樂暫得新。\n洙泗輟微響，漂流逮狂秦。\n詩書復何罪？一朝成灰塵。\n區區諸老翁，爲事誠殷勤。\n如何絕世下，六籍無一親。\n終日馳車走，不見所問津。\n若復不快飲，空負頭上巾。\n但恨多謬誤，君當恕醉人。',
  },
  {
    id: 'poem-weijin-ziyege',
    category: 'poem',
    dynasty: 'weijin',
    title: '子夜歌',
    source: '子夜',
    description: '魏晉南北朝時期經典詩歌，作者為子夜。',
    content: '【其一】\n落日出前門，瞻矚見子度。\n冶容多姿鬢，芳香已盈路。\n【其二】\n芳是香所爲，冶容不敢堂。\n天不奪人願，故使儂見郎。\n【其三】\n宿昔不梳頭，絲髮被兩肩。\n婉伸郎膝上，何處不可憐。\n【其四】\n自從別歡來，奩器了不開。\n頭亂不敢理，粉拂生黃衣。\n【其五】\n崎嶇相怨慕，始獲風雲通。\n玉林語石闕，悲思兩心同。\n【其六】\n見娘喜容媚，願得結金蘭。\n空織無經緯，求匹理自難。\n【其七】\n始欲識郎時，兩心望如一。\n理絲入殘機，何悟不成匹。\n【其八】\n前絲斷纏綿，意欲結交情。\n春蠶易感化，絲子已復生。\n【其九】\n今夕已歡別，合會在何時？\n明燈照空局，悠然未有期。\n【其十】\n自從別郎來，何日不諮嗟。\n黃檗鬱成林，當奈苦心多。\n【其十一】\n高山種芙蓉，復經黃檗塢。\n果得一蓮時，流離嬰辛苦。\n【其十二】\n朝思出前門，暮思還後渚。\n語笑向誰道，腹中陰憶汝。\n【其十三】\n攬枕北窗臥，郎來就儂嬉。\n小喜多唐突，相憐能幾時。\n【其十四】\n駐箸不能食，蹇蹇步闈裏。\n投瓊著局上，終日走博子。\n【其十五】\n郎爲傍人取，負儂非一事。\n摛門不安橫，無複相關意。\n【其十六】\n年少當及時，嗟跎日就老。\n若不信儂語，但看霜下草。\n【其十七】\n綠攬迮題錦，雙裙今復開。\n已許腰中帶，誰共解羅衣。\n【其十八】\n常慮有貳意，歡今果不齊。\n枯魚就濁水，長與清流乖。\n【其十九】\n歡愁儂亦慘，郎笑我便喜。\n不見連理樹，異根同條起。\n【其二十】\n感歡初殷勤，嘆子後遼落。\n打金側玳瑁，外豔裏懷薄。\n【其二十一】\n別後涕流連，相思情悲滿。\n憶子腹糜爛，肝腸尺寸斷。\n【其二十二】\n道近不得數，遂致盛寒違。\n不見東流水。何時復西歸。\n【其二十三】\n誰能思不歌，誰能飢不食。\n日冥當戶倚，惆悵底不億。\n【其二十四】\n攬裙未結帶，約眉出前窗。\n羅裳易飄揚，小開罵春風。\n【其二十五】\n舉酒待相勸，酒還杯亦空。\n願因微觴會，心感色亦同。\n【其二十六】\n夜覺百思纏，憂嘆涕流襟。\n徒懷傾筐情，郎誰明儂心。\n【其二十七】\n儂年不及時，其於作乖離。\n素不如浮萍，轉動春風移。\n【其二十八】\n夜長不得眠，轉側聽更鼓。\n無故歡相逢，使儂肝腸苦。\n【其二十九】\n歡從何處來？端然有憂色。\n三喚不一應，有何比松柏？\n【其三十】\n念愛情慊慊，傾倒無所惜。\n重簾持自鄣，誰知許厚薄。\n【其三十一】\n氣清明月朗，夜與君共嬉。\n郎歌妙意曲，儂亦吐芳詞。\n【其三十二】\n驚風急素柯，白日漸微蒙。\n郎懷幽閨性，儂亦恃春容。\n【其三十三】\n夜長不得眠，明月何灼灼。\n想聞散喚聲，虛應空中諾。\n【其三十四】\n人各既疇匹，我志獨乖違。\n風吹冬簾起，許時寒薄飛。\n【其三十五】\n我念歡的的，子行由豫情。\n霧露隱芙蓉，見蓮不分明。\n【其三十六】\n儂作北辰星，千年無轉移。\n歡行白日心，朝東暮還西。\n【其三十七】\n憐歡好情懷，移居作鄉里。\n桐樹生門前，出入見梧子。\n【其三十八】\n遣信歡不來，自往復不出。\n金銅作芙蓉，蓮子何能實。\n【其三十九】\n初時非不密，其後日不如。\n回頭批櫛脫，轉覺薄志疏。\n【其四十】\n寢食不相忘，同坐復俱起。\n玉藕金芙蓉，無稱我蓮子。\n【其四十一】\n恃愛如欲進，含羞未肯前。\n口朱發豔歌，玉指弄嬌弦。\n【其四十二】\n朝日照綺錢，光風動紈素。\n巧笑茜兩犀，美目揚雙蛾。',
  },
  {
    id: 'poem-weijin-youxianshishisishou',
    category: 'poem',
    dynasty: 'weijin',
    title: '遊仙詩十四首',
    source: '郭璞',
    description: '魏晉南北朝時期經典詩歌，作者為郭璞。',
    content: '【其一】\n京華遊俠窟，山林隱遁棲。\n朱門何足榮？未若託蓬萊。\n臨源挹清波，陵岡掇丹荑。\n靈溪可潛盤，安事登雲梯。\n漆園有傲吏，萊氏有逸妻。\n進則保龍見，退爲觸蕃羝。\n高蹈風塵外，長揖謝夷齊。\n【其二】\n青溪千餘仞，中有一道士。\n雲生樑棟間，風出窗戶裏。\n借問此何誰，雲是鬼谷子。\n翹跡企穎陽，臨河思洗耳。\n閶闔西南來，潛波渙鱗起。\n靈妃顧我笑，粲然啓玉齒。\n蹇修時不存，要之將誰使。\n【其三】\n翡翠戲蘭苕，容色更相鮮。\n綠蘿結高林，蒙籠蓋一山。\n中有冥寂士，靜嘯撫清弦。\n放情凌霄外，嚼蕊挹飛泉。\n赤松臨上游，駕鴻乘紫煙。\n左挹浮丘袖，右拍洪崖肩。\n借問蜉蝣輩，寧知龜鶴年。\n【其四】\n六龍安可頓，運流有代謝。\n時變感人思，已秋復願夏。\n淮海變微禽，吾生獨不化。\n雖欲騰丹溪，雲螭非我駕。\n愧無魯陽德，回日向三舍。\n臨川哀年邁，撫心獨悲吒。\n【其五】\n逸翮思拂霄，迅足羨遠遊。\n清源無增瀾，安得運吞舟。\n珪璋雖特達，明月難闇投。\n潛穎怨清陽，陵苕哀素秋。\n悲來惻丹心，零淚緣纓流。\n【其六】\n雜縣寓魯門，風暖將爲災。\n吞舟湧海底，高浪駕蓬萊。\n神仙排雲出，但見金銀臺。\n陵陽挹丹溜，容成揮玉杯。\n姮娥揚妙音，洪崖頷其頤。\n升降隨長煙，飄颻戲九垓。\n奇齢邁五龍，千歲方嬰孩。\n燕昭無靈氣，漢武非仙才。\n【其七】\n晦朔如循環，月盈已復魄。\n蓐收清西陸，朱羲將由白。\n寒露拂陵苕，女蘿辭松柏。\n蕣榮不終朝，蜉蝣豈見夕。\n圓丘有奇章，鐘山出靈液。\n王孫列八珍，安期煉五石。\n長揖當途人，去來山林客。\n【其八】\n暘谷吐靈曜，扶桑森千丈。\n朱霞升東山，朝日何晃朗。\n迴風流曲欞，幽室發逸響。\n悠然心永懷，眇爾自遐想。\n仰思舉雲翼，延首矯玉掌。\n嘯傲遺世羅，縱情在獨往。\n明道雖若昧，其中有妙象。\n希賢宜勵德，羨魚當結網。\n【其九】\n採藥遊名山，將以救年頹。\n呼吸玉滋液，妙氣盈胸懷。\n登仙撫龍駟，迅駕乘奔雷。\n鱗裳逐電曜，雲蓋隨風回。\n手頓羲和轡，足蹈閶闔開。\n東海猶蹄涔，崑崙螻蟻堆。\n遐邈冥茫中，俯視令人哀。\n【其十】\n璇臺冠昆嶺，西海濱招搖。\n瓊林籠藻映，碧樹疏英翹。\n丹泉溧朱沫，黑水鼓玄濤。\n尋仙萬餘日，今乃見子喬。\n振發睎翠霞，解褐禮絳霄。\n總轡臨少廣，盤虯舞雲軺。\n永偕帝鄉侶，千齢共逍遙。\n【其十一】\n吐納致真和，一朝忽靈蛻。\n飄然凌太清，眇爾景長滅。\n【其十二】\n縱酒濛汜濱，結駕尋木末。\n翹手攀金梯，飛步登玉闕。\n左顧擁方目，右眷極朱發。\n【其十三】\n四瀆流如淚，五嶽羅若垤。\n尋我青雲友，永與時人絕。\n【其十四】\n靜嘆亦何念，悲此妙齢逝。\n在世無千月，命如秋葉蔕。\n蘭生蓬芭間，榮曜常幽翳。\n【其十五】\n登嶽採五芝，涉澗將六草。\n散發蕩玄溜，終年不華皓。\n【其十六】\n放浪林澤外，被髮師巖穴。\n彷彿若士姿，夢想遊列𡙇。\n【其十七】\n翹首望太清，朝雲無增景。\n雖欲思靈化，龍津未易上。\n【其十八】\n安見山林士，擁膝對巖蹲。\n【其十九】\n嘯嗷遺俗羅，得此生。',
  },
  {
    id: 'poem-weijin-zashishishou',
    category: 'poem',
    dynasty: 'weijin',
    title: '雜詩十首',
    source: '張協',
    description: '魏晉南北朝時期經典詩歌，作者為張協。',
    content: '【其一】\n秋夜涼風起，清氣蕩暄濁。\n蜻蛚吟階下，飛蛾拂明燭。\n君子從遠役，佳人守煢獨。\n離居幾何時，鑽燧忽改木。\n房櫳無行跡，庭草萋以綠。\n青苔依空牆，蜘蛛網四屋。\n感物多所懷，沈憂結心曲。\n【其二】\n大火流坤維，白日馳西陸。\n浮陽映翠林，回飈扇綠竹。\n飛雨灑朝蘭，輕露棲業菊。\n龍蟄暄氣凝，天高萬物肅。\n弱條不重結，芳蕤豈再馥。\n人生瀛海內，忽如鳥過目。\n川上之歡逝，前修以自勖。\n【其三】\n金風扇素節，丹霞啓陰期。\n騰雲似湧煙，密雨如散絲。\n寒花發黃採，秋草含錄滋。\n閒居玩萬物，離羣戀所思。\n案無蕭氏牘，庭無貢公綦。\n高尚遺王侯，道積自成基。\n至人不嬰物，餘風足染時。\n【其四】\n朝霞迎白日，丹氣臨暘谷。\n翳翳結繁雲，森森散雨足。\n輕風摧勁草，凝霜竦高木。\n密葉日夜疏，叢林森如束。\n疇昔嘆時遲，晚節悲年促。\n歲暮懷百憂，將從季主卜。\n【其五】\n昔我資章甫，聊以適諸越。\n行行入幽荒，甌駱從祝髮。\n窮年非所用，此貨將安設。\n瓴甋誇璵璠，魚目笑明月。\n不見郢中歌，能否居然別。\n陽春無和者，巴人皆下節。\n流俗多昏迷，此理誰能察。\n【其六】\n朝登魯陽關，狹路峭且深。\n流澗萬餘丈，圍木數千尋。\n咆虎響窮山，鳴鶴聒空林。\n悽風爲我嘯，百籟坐自吟。\n感物多思情，在險易常心。\n劫來戒不虞，挺轡越飛岑。\n王陽驅九折，周文走岑崟。\n經阻貴勿遲，此理著來今。\n【其七】\n此鄉非吾地，此郭非吾城。\n羈旅無定心，翩翩如懸旌。\n出睹軍馬陣，入聞鞞鼓聲。\n常懼羽檄飛，神武一朝徵。\n長鋏鳴鞘中，烽火列邊亭。\n舍我衡門衣，更被縵胡纓。\n疇昔懷微志，帷幕竊所經。\n何必操干戈，堂上有奇兵。\n折衝樽俎間，制勝在兩楹。\n巧遲不足稱，拙速乃垂名。\n【其八】\n述職投邊城，羈束戎旅間。\n下車如昨日，望舒四五圓。\n借問此何時，胡蝶飛南園。\n流波戀舊浦，行雲思故山。\n閩越衣文蛇，胡馬願度燕。\n風土安所習，由來有固然。\n【其九】\n結宇窮岡曲，耦耕幽藪陰。\n荒庭寂以間，幽岫峭且深。\n悽風起東谷，有渰興南岑。\n雖無箕畢期，膚寸自成霖。\n澤雉登壟雊，寒猿擁條吟。\n溪壑無人跡，荒楚鬱蕭森。\n投耒循岸垂，時聞樵採音。\n重基可擬志，回淵可比心。\n養真尚我爲，道勝貴陸沈。\n遊思竹素園，寄辭翰墨林。\n【其十】\n墨蜧躍重淵，商羊舞野庭。\n飛廉應南箕，豐隆迎號屏。\n雲根臨八極，雨足灑四溟。\n霖瀝過二旬，散漫亞九齡。\n階下伏拉湧，堂上水衣生。\n洪潦浩方割，人懷昏墊情。\n沈液漱陳根，綠葉腐秋莖。\n裏無曲突煙，路無行輪聲。\n環堵自頹毀，垣閭不隱形。\n尺燼重尋桂，紅粒貴瑤瓊。\n君子守固窮，在約不爽貞。\n雖榮田方贈，慚爲溝壑名。\n取志於陵子，比足黔婁生。',
  },
  {
    id: 'poem-weijin-zashishiershou',
    category: 'poem',
    dynasty: 'weijin',
    title: '雜詩十二首',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '【其一】\n人生無根蒂，飄如陌上塵。\n分散逐風轉，此已非常身。\n落地爲兄弟，何必骨肉親！\n得歡當作樂，斗酒聚比鄰。\n盛年不重來，一日難再晨。\n及時當勉勵，歲月不待人。\n【其二】\n白日淪西河，素月出東嶺。\n遙遙萬里暉，蕩蕩空中景。\n風來入房戶，夜中枕蓆冷。\n氣變悟時易，不眠知夕永。\n欲言無予和，揮杯勸孤影。\n日月擲人去，有志不獲騁。\n念此懷悲悽，終曉不能靜。\n【其三】\n榮華難久居，盛衰不可量。\n昔爲叄春蕖，今作秋蓮房。\n嚴霜結野草，枯悴未遽央。\n日月還復周，我去不再陽。\n眷眷往昔時，憶此斷人腸。\n【其四】\n丈夫志四海，我願不知老。\n親戚共一處，子孫還相保。\n觴弦肆朝日，樽中酒不燥。\n緩帶盡歡娛，起晚眠常早。\n孰若當世時，冰炭滿懷抱。\n百年歸丘壟，用此空名道！\n【其五】\n憶我少壯時，無樂自欣豫。\n猛志逸四海，騫翮思遠翥。\n荏苒歲月頹，此心稍已去。\n值歡無復娛，每每多憂慮。\n氣力漸衰損，轉覺日不如。\n壑舟無須臾，引我不得住。\n前塗當幾許，未知止泊處。\n古人惜寸陰，念此使人懼。\n【其六】\n昔聞長者言，掩耳每不喜。\n奈何五十年，忽已親此事。\n求我盛年歡，一毫無複意。\n去去轉欲速，此生豈再值。\n傾家持作樂，竟此歲月駛。\n有子不留金，何用身後置！\n【其七】\n日月不肯遲，四時相催迫。\n寒風拂枯條，落葉掩長陌。\n弱質與運頹，玄發早已白。\n素標插人頭，前途漸就窄。\n家爲逆旅舍，我如當去客。\n去去欲何之？南山有舊宅。\n【其八】\n代耕本非望，所業在田桑。\n躬親未曾替，寒餒常糟糠。\n豈期過滿腹，但願飽粳糧。\n御冬足大布，粗絺以應陽。\n正爾不能得，哀哉亦可傷！\n人皆盡獲宜，拙生失其方。\n理也可奈何！且爲陶一觴。\n【其九】\n遙遙從羈役，一心處兩端。\n掩淚汛東逝，順流追時遷。\n日沒星與昴，勢翳西山顛。\n蕭條隔天涯，惆悵念常餐。\n慷慨思南歸，路遐無由緣。\n關梁難虧替，絕音寄斯篇。\n【其十】\n閒居執蕩志，時駛不可稽。\n驅役無停息，軒裳逝東崖。\n沈陰擬薰麝，寒氣激我懷。\n歲月有常御，我來淹已彌。\n慷慨憶綢繆，此情久已離。\n荏苒經十載，暫爲人所羈。\n庭宇翳餘木，倏忽日月虧。\n【其十一】\n我行未雲遠，回顧慘風涼。\n春燕應節起，高飛拂塵梁。\n邊雁悲無所，代謝歸北鄉。\n離昆鳴清池，涉暑經秋霜。\n愁人難爲辭，遙遙春夜長。\n【其十二】\n嫋嫋松標崖，婉孌柔童子。\n年始叄五間，喬柯何可倚。\n養色含精氣，粲然有心理。',
  },
  {
    id: 'poem-weijin-nigujiushou',
    category: 'poem',
    dynasty: 'weijin',
    title: '擬古九首',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '【其一】\n榮榮窗下蘭，密密堂前柳。\n初與君別時，不謂行當久。\n出門萬里客，中道逢嘉友。\n未言心相醉，不在接杯酒。\n蘭枯柳亦衰，遂令此言負。\n多謝諸少年，相知不中厚。\n意氣傾人命，離隔復何有？\n【其二】\n辭家夙嚴駕，當往志無終。\n問君今何行？非商復非戎。\n聞有田子春，節義爲士雄。\n斯人久已死，鄉里習其風。\n生有高世名，既沒傳無窮。\n不學狂馳子，直在百年中。\n【其三】\n仲春遘時雨，始雷發東隅。\n衆蟄各潛駭，草木從橫舒。\n翩翩新來燕，雙雙入我廬。\n先巢故尚在，相將還舊居。\n自從分別來，門庭日荒蕪。\n我心固匪石，君情定何如？\n【其四】\n迢迢百尺樓，分明望四荒。\n暮作歸雲宅，朝爲飛鳥堂。\n山河滿目中，平原獨茫茫。\n古時功名士，慷慨爭此場。\n一旦百歲後，相與還北邙。\n松柏爲人伐，高墳互低昂。\n頹基無遺主，遊魂在何方？\n榮華誠足貴，亦復可憐傷！\n【其五】\n東方有一士，被服常不完。\n三旬九遇食，十年著一冠。\n辛勤無此比，常有好容顏。\n我欲觀其人，晨去越河關。\n青松夾路生，白雲宿檐端。\n知我故來意，取琴爲我彈。\n上弦驚別鶴，下弦操孤鸞。\n願留就君住，從今至歲寒。\n【其六】\n蒼蒼谷中樹，冬夏常如茲。\n年年見霜雪，誰謂不知時？\n厭聞世上語，結友到臨淄。\n稷下多談士，指彼決吾疑。\n裝束既有日，已與家人辭。\n行行停出門，還坐更自思。\n不怨道里長，但畏人我欺。\n萬一不合意，永爲世笑之。\n伊懷難具道，爲君作此詩。\n【其七】\n日暮天無雲，春風扇微和。\n佳人美清夜，達曙酣且歌。\n歌竟長嘆息，持此感人多。\n皎皎雲間月，灼灼葉中華。\n豈無一時好，不久當如何？\n【其八】\n少時壯且厲，撫劍獨行遊。\n誰言行遊近，張掖至幽州。\n飢食首陽薇，渴飲易水流。\n不見相知人，惟見古時丘。\n路邊兩高墳，伯牙與莊周。\n此士難再得，吾行欲何求？\n【其九】\n種桑長江邊，三年望當採。\n枝條始欲茂，忽值山河改。\n柯葉自摧折，根株浮滄海。\n春蠶既無食，寒衣欲誰待？\n本不植高原，今日復何悔！',
  },
  {
    id: 'classic-weijin-beishanyiwen',
    category: 'classic',
    dynasty: 'weijin',
    title: '北山移文',
    source: '孔稚珪',
    description: '《古文觀止》收錄之經典名篇，作者為孔稚珪。',
    content: '鐘山之英，草堂之靈，馳煙驛路，勒移山庭：\n夫以耿介拔俗之標，蕭灑出塵之想，度白雪以方潔，幹青雲而直上，吾方知之矣。\n若其亭亭物表，皎皎霞外，芥千金而不眄，屣萬乘其如脫，聞鳳吹於洛浦，值薪歌於延瀨，固亦有焉。\n豈期終始參差，蒼黃翻覆，淚翟子之悲，慟朱公之哭。乍回跡以心染，或先貞而後黷，何其謬哉！嗚呼，尚生不存，仲氏既往，山阿寂寥，千載誰賞！\n世有周子，雋俗之士，既文既博，亦玄亦史。然而學遁東魯，習隱南郭，偶吹草堂，濫巾北嶽。誘我鬆桂，欺我雲壑。雖假容於江皋，乃纓情於好爵。\n其始至也，將欲排巢父，拉許由，傲百氏，蔑王侯。風情張日，霜氣橫秋。或嘆幽人長往，或怨王孫不遊。談空空於釋部，覈玄玄於道流，務光何足比，涓子不能儔。\n及其鳴騶入谷，鶴書赴隴，形馳魄散，志變神動。爾乃眉軒席次，袂聳筵上，焚芰制而裂荷衣，抗塵容而走俗狀。風雲悽其帶憤，石泉咽而下愴，望林巒而有失，顧草木而如喪。\n至其鈕金章，綰墨綬，跨屬城之雄，冠百里之首。張英風於海甸，馳妙譽於浙右。道帙長擯，法筵久埋。敲撲喧囂犯其慮，牒訴倥傯裝其懷。琴歌既斷，酒賦無續，常綢繆於結課，每紛綸於折獄，籠張趙於往圖，架卓魯於前籙，希蹤三輔豪，馳聲九州牧。\n使我高霞孤映，明月獨舉，青松落陰，白雲誰侶？磵戶摧絕無與歸，石徑荒涼徒延佇。至於還飆入幕，寫霧出楹，蕙帳空兮夜鶴怨，山人去兮曉猨驚。昔聞投簪逸海岸，今見解蘭縛塵纓。於是南嶽獻嘲，北隴騰笑，列壑爭譏，攢峯竦誚。慨遊子之我欺，悲無人以赴吊。\n故其林慚無盡，澗愧不歇，秋桂遣風，春蘿罷月。騁西山之逸議，馳東皋之素謁。\n今又促裝下邑，浪栧上京，雖情殷於魏闕，或假步于山扃。豈可使芳杜厚顏，薜荔蒙恥，碧嶺再辱，丹崖重滓，塵遊躅於蕙路，污淥池以洗耳。宜扃岫幌，掩雲關，斂輕霧，藏鳴湍。截來轅於谷口，杜妄轡於郊端。於是叢條瞋膽，疊穎怒魄。或飛柯以折輪，乍低枝而掃跡。請回俗士駕，爲君謝逋客。',
  },
  {
    id: 'poem-weijin-bainiangeshishou',
    category: 'poem',
    dynasty: 'weijin',
    title: '百年歌十首 ',
    source: '陸機',
    description: '魏晉南北朝時期經典詩歌，作者為陸機。',
    content: '【其一】\n一十時。\n顏如蕣華曄有暉。\n體如飄風行如飛。\n孌彼孺子相追隨。\n終朝出遊薄暮歸。\n六情逸豫心無違。\n清酒將炙奈樂何。\n清酒將炙奈樂何。\n【其二】\n二十時。\n膚體彩澤人理成。\n美目淑貌灼有榮。\n被服冠帶麗且清。\n光車駿馬遊都城。\n高談雅步何盈盈。\n清酒將炙奈樂何。\n清酒將炙奈樂何。\n【其三】\n三十時。\n行成名立有令聞。\n力可扛鼎志幹雲。\n食如漏卮氣如燻。\n辭家觀國綜典文。\n高冠素帶煥翩紛。\n清酒將炙奈樂何。\n清酒將炙奈樂何。\n【其四】\n四十時。\n體力克壯志方剛。\n跨州越郡還帝鄉。\n出入承明擁大璫。\n清酒將炙奈樂何。\n清酒將炙奈樂何。\n【其五】\n五十時。\n荷旄仗節鎮邦家。\n鼓鍾嘈囋趙女歌。\n羅衣綷粲金翠華。\n言笑雅舞相經過。\n清酒將炙奈樂何。\n清酒將炙奈樂何。\n【其六】\n六十時。\n年亦耆艾業亦隆。\n驂駕四牡入紫宮。\n軒冕婀那翠雲中。\n子孫昌盛家道豐。\n清酒將炙奈樂何。\n清酒將炙奈樂何。\n【其七】\n七十時。\n精爽頗損膂力愆。\n清水明鏡不欲觀。\n臨樂對酒轉無歡。\n攬形修發獨長嘆。\n【其八】\n八十時。\n明已損目聰去耳。\n前言往行不復紀。\n辭官致祿歸桑梓。\n安車駟馬入舊裏。\n樂事告終憂事始。\n【其九】\n九十時。\n日告耽瘁月告衰。\n形體雖是志意非。\n言多謬誤心多悲。\n子孫朝拜或問誰。\n指景玩日慮安危。\n感念平生淚交揮。\n【其十】\n百歲時。\n盈數已登肌肉單。\n四支百節還相患。\n目若濁鏡口垂涎。\n呼吸顰蹙反側難。\n茵褥滋味不復安。',
  },
  {
    id: 'poem-weijin-hehuanshiwushou',
    category: 'poem',
    dynasty: 'weijin',
    title: '合歡詩五首',
    source: '楊方（公回）',
    description: '魏晉南北朝時期經典詩歌，作者為楊方（公回）。',
    content: '【其一】\n虎嘯穀風起，龍躍景雲浮。\n同聲好相應，同氣自相求。\n我情與子親，譬如影追軀。\n食共並根穗，飲共連理杯。\n衣共雙絲絹，寢共無縫裯。\n居願接膝坐，行願攜手趨。\n子靜我不動，子游我不留。\n齊彼同心鳥，譬此比目魚。\n情至斷金石，膠漆未爲牢。\n但願長無別，合形作一軀。\n生爲並身物，死爲同棺灰。\n秦氏自言至，我情不可儔。\n【其二】\n磁石引長針，陽燧下炎煙。\n宮商聲相和，心同自相親。\n我情與子合，亦如影追身。\n寢共織成被，絮用同功綿。\n暑搖比翼扇，寒坐並肩氈。\n子笑我必哂，子戚我無歡。\n來與子共跡，去與子同塵。\n齊彼蛩蛩獸，舉動不相捐。\n惟願長無別，合形作一身。\n生有同室好，死成並棺民。\n徐氏自言至，我情不可陳。\n【其三】\n獨坐空室中，愁有數千端。\n悲響答愁嘆，哀涕應苦言。\n彷徨四顧望，白日入西山。\n不睹佳人來，但見飛鳥還。\n飛鳥亦何樂，夕宿自作羣。\n【其四】\n飛黃銜長轡，翼翼回輕輪。\n俯涉淥水澗，仰過九層山。\n修途曲且險，秋草生兩邊。\n黃華如沓金，白花如散銀。\n青敷羅翠彩，絳葩象赤雲。\n爰有承露枝，紫榮合素芬。\n扶疏垂清藻，布翹芳且鮮。\n目爲豔彩回，心爲奇色旋。\n撫心悼孤客，俯仰還自憐。\n歭𣦠向壁嘆，攬筆作此文。\n【其五】\n南鄰有奇樹，承春挺素華。\n豐翹被長條，綠葉蔽朱柯。\n因風吐微音，芳氣入紫霞。\n我心羨此木，願徒著予家。\n夕得遊其下，朝得弄其葩。\n爾根深且堅，予宅淺且洿。\n移植良無期，嘆息將如何。',
  },
  {
    id: 'poem-weijin-daowangshisanshou',
    category: 'poem',
    dynasty: 'weijin',
    title: '悼亡詩三首',
    source: '潘岳',
    description: '魏晉南北朝時期經典詩歌，作者為潘岳。',
    content: '【其一】\n荏苒冬春謝，寒暑忽流易。\n之子歸窮泉，重壤永幽隔。\n私懷誰克從，淹留亦何益。\n黽勉恭朝命，迴心反初役。\n望廬思其人，入室想所歷。\n幃屏無彷彿，翰墨有餘跡。\n流芳未及歇，遺掛猶在壁。\n悵恍如或存，回惶忡驚惕。\n如彼翰林鳥，雙棲一朝只。\n如彼遊川魚，比目中路析。\n春風緣隙來，晨霤承檐滴。\n寢息何時忘，沈憂日盈積。\n庶幾有時衰，莊缶猶可擊。\n【其二】\n皎皎窗中月，照我室南端。\n清商應秋至，溽暑隨節闌。\n凜凜涼風升，始覺夏衾單。\n豈曰無重纊，誰與同歲寒。\n歲寒無與同，朗月何朧朧。\n展轉盻枕蓆，長簟竟牀空。\n牀空委清塵，室虛來悲風。\n獨無李氏靈，彷彿睹爾容。\n撫衿長歡息，不覺涕沾胸。\n沾胸安能已，悲懷從中起。\n寢興目存形，遺音猶在耳。\n上慚東門吳，下愧蒙莊子。\n賦詩欲言志，此志難具紀。\n命也可奈何，長戚自令鄙。\n【其三】\n曜靈運天機，四節代遷逝。\n悽悽朝露凝，烈烈夕風厲。\n奈何悼淑儷，儀容永潛翳。\n念此如昨日，誰知已卒歲。\n改服從朝政，哀心寄私制。\n茵幬張故房，朔望臨爾祭。\n爾祭詎幾時，朔望忽復盡。\n衾裳一毀撤，千載不復引。\n亹亹期月周，慼慼彌相愍。\n悲懷感物來，泣涕應情隕。\n駕言陟東阜，望墳思紆軫。\n徘徊墟墓間，欲去復不忍。\n徘徊不忍去，徙倚步踟躕。\n落葉委埏側，枯荄帶墳隅。\n孤魂獨煢煢，安知靈與無。\n投心遵朝命，揮涕強就車。\n誰謂帝宮遠，路極悲有餘。',
  },
  {
    id: 'poem-weijin-yongpinshiqishou',
    category: 'poem',
    dynasty: 'weijin',
    title: '詠貧士七首',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '【其一】\n萬族各有託，孤雲獨無依。\n曖曖空中滅，何時見餘暉。\n朝霞開宿霧，衆鳥相與飛。\n遲遲出林翮，未夕復來歸。\n量力守故轍，豈不寒與飢？\n知音苟不存，已矣何所悲。\n【其二】\n淒厲歲雲暮，擁褐曝前軒。\n南圃無遺秀，枯條盈北園。\n傾壺絕餘瀝，窺竈不見煙。\n詩書塞座外，日昃不遑研。\n閒居非陳厄，竊有慍見言。\n何以慰吾懷，賴古多此賢。\n【其三】\n榮叟老帶索，欣然方彈琴。\n原生納決履，清歌暢商音。\n重華去我久，貧士世相尋。\n弊襟不掩肘，藜羹常乏斟。\n豈忘襲輕裘，苟得非所欽。\n賜也徒能辨，乃不見吾心。\n【其四】\n安貧守賤者，自古有黔婁。\n好爵吾不榮，厚饋吾不酬。\n一旦壽命盡，弊服仍不周。\n豈不知其極，非道故無憂。\n從來將千載，未復見斯儔。\n朝與仁義生，夕死復何求。\n【其五】\n袁安困積雪，邈然不可幹。\n阮公見錢入，即日棄其官。\n芻槁有常溫，採莒足朝飡。\n豈不實辛苦，所懼非飢寒。\n貧富常交戰，道勝無戚顏。\n至德冠邦閭，清節映西關。\n【其六】\n仲蔚愛窮居，繞宅生蒿蓬。\n翳然絕交遊，賦詩頗能工；\n舉世無知者，止有一劉龔。\n此士胡獨然？實由罕所同；\n介焉安其業，所樂非窮通。\n人事固以拙，聊得長相從。\n【其七】\n昔在黃子廉，彈冠佐名州。\n一朝辭吏歸，清貧略難儔。\n年飢感仁妻，泣涕向我流。\n丈夫雖有志，固爲兒女憂。\n惠孫一晤嘆，腆贈竟莫酬。\n誰雲固窮難，邈哉此前修。',
  },
  {
    id: 'poem-weijin-dushishujiuzhang',
    category: 'poem',
    dynasty: 'weijin',
    title: '讀史述九章',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '【夷齊】\n二子讓國，相將海隅。\n天人革命，絕景窮居。\n采薇高歌，慨想黃虞。\n貞風淩俗，爰感懦夫。\n【箕子】\n去鄉之感，猶有遲遲。\n矧伊代謝，觸物皆非。\n哀哀箕子，雲胡能夷！\n狡童之歌，悽矣其悲。\n【管鮑】\n知人未易，相知實難。\n淡美初交，利乖歲寒。\n管生稱心，鮑叔必安。\n奇情雙亮，令名俱完。\n【程杵】\n遺生良難，士爲知己。\n望義如歸，允伊二子。\n程生揮劍，懼茲餘恥。\n令德永聞，百代見紀。\n【七十二弟子】\n恂恂舞雩，莫曰匪賢。\n俱映日月，共餐至言。\n慟由才難，感爲情牽。\n回也早夭，賜獨長年。\n【屈賈】\n進德修業，將以及時。\n如彼稷契，孰不願之？\n嗟乎二賢，逢世多疑。\n候瞻寫志，感鵩獻辭。\n【韓非】\n豐狐隱穴，以文自殘。\n君子失時，白首抱關。\n巧行居災，忮辯召患。\n哀矣韓生，竟死《說難》。\n【魯二儒】\n易代隨時，迷變則愚。\n介介若人，特爲貞夫。\n德不百年，污我詩書。\n逝然不顧，被褐幽居。\n【張長公】\n遠哉長公，蕭然何事？\n世路多端，皆爲我異。\n斂轡朅來，獨養其志。\n寢跡窮年，誰知斯意？',
  },
  {
    id: 'poem-weijin-mingzi',
    category: 'poem',
    dynasty: 'weijin',
    title: '命子',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '悠悠我祖，爰自陶唐。\n邈爲虞賓，歷世重光。\n御龍勤夏，豕韋翼商。\n穆穆司徒，厥族以昌。\n紛紛戰國，漠漠衰周，\n鳳隱於林，幽人在丘。\n逸虯繞雲，奔鯨駭流。\n天集有漢，眷予憫侯。\n於赫憫候，運當攀龍。\n撫劍風邁，顯茲武功。\n書誓山河，啓土開封。\n亹亹丞相，允迪前蹤。\n渾渾長源，鬱郁洪柯。\n羣川載導，衆條載羅。\n時有語默，運因隆窊，\n在我中晉，業融長沙。\n桓桓長沙，伊勳伊德。\n天子疇我，專征南國。\n功遂辭歸，臨寵不忒。\n孰謂斯心，而近可得。\n肅矣我祖，慎終如始。\n直方二臺，惠和千里。\n於穆仁考，淡焉虛止。\n寄跡風雲，冥茲慍喜。\n嗟餘寡陋，瞻望弗及。\n顧慚華鬢，負影隻立。\n三千之罪，無後爲急。\n我誠念哉，呱聞爾泣。\n卜雲嘉日，佔亦良時。\n名汝曰儼，字汝求思。\n溫恭朝夕，念茲在茲。\n尚想孔伋，庶其企而。\n厲夜生子，遽而求火。\n凡百有心，奚特於我。\n既見其生，實欲其可。\n人亦有言，斯情無假。\n日居月諸，漸免於孩。\n福不虛至，禍亦易來。\n夙興夜寐，願爾斯才；\n爾之不才，亦已焉哉！',
  },
  {
    id: 'poem-weijin-nisichoushisishou',
    category: 'poem',
    dynasty: 'weijin',
    title: '擬四愁詩四首',
    source: '傅玄',
    description: '魏晉南北朝時期經典詩歌，作者為傅玄。',
    content: '【其一】\n我所思兮在瀛洲，願爲雙鵠戲中流。\n牽牛織女期在秋，山高水深路無由。\n愍予不遘嬰殷憂，佳人貽我明月珠。\n何以要之比目魚，海廣無舟悵勞劬。\n寄言飛龍天馬駒，風起雲披飛龍逝。\n驚波滔天馬不厲，何爲多念心憂泄。\n【其二】\n我所思兮在珠崖，願爲比翼浮清池。\n剛柔合德配二儀，形影一絕長別離。\n愍予不遘情如攜，佳人貽我蘭蕙草。\n何以要之同心鳥，火熱水深憂盈抱。\n申以琬琰夜光寶，卞和既沒玉不察。\n存若流光忽電滅，何爲多念獨蘊結。\n【其三】\n我所思兮在瀛昆，願爲鹿𪊤窺虞淵。\n日月回耀照景天，參辰曠隔會無緣。\n愍予不遘罹百艱，佳人贈我蘇合香。\n何以要之翠鴛鴦，懸度弱水川無樑。\n申以錦衣文繡裳，三光騁邁景不留。\n鮮矣民生忽如浮，何爲多念只自愁。\n【其四】\n我所思兮在朔方，願爲飛燕俱南翔。\n煥乎人道著三光，胡越殊心生異鄉。\n愍予不遘罹百殃，佳人貽我羽葆纓。\n何以要之影與形，永增夏結繁華零。\n申以日月指明星，星辰有翳日月移。\n駑馬哀鳴慚不馳，何爲多念徒自虧。',
  },
  {
    id: 'poem-weijin-qingshiwushou',
    category: 'poem',
    dynasty: 'weijin',
    title: '情詩五首',
    source: '張華',
    description: '魏晉南北朝時期經典詩歌，作者為張華。',
    content: '【其一】\n北方有佳人，端坐鼓鳴琴。\n終晨撫管絃，日夕不成音。\n憂來結不解，我思存所欽。\n君子尋時役，幽妾懷苦心。\n初爲三載別，於今久滯淫。\n昔耶生戶牖，庭內自成陰。\n翔鳥鳴翠偶，草蟲相和吟。\n心悲易感激，俯仰淚流衿。\n願託晨風翼，束帶侍衣衾。\n【其二】\n明月曜清景，曨光照玄墀。\n幽人守靜夜，回身入空帷。\n束帶俟將朝，廓落晨星稀。\n寐假交精爽，覿我佳人姿。\n巧笑媚歡靨，聯娟眸與眉。\n寤言增長嘆，悽然心獨悲。\n【其三】\n清風動帷簾，晨月嘆幽房。\n佳人處遐遠，蘭室無容光。\n襟懷擁虛景，輕衾覆空牀。\n居歡惜夜促，在戚怨宵長。\n拊枕獨嘯嘆，感慨心內傷。\n【其四】\n君居北海陽，妾在江南陰。\n懸邈修塗遠，山川阻且深。\n承歡注隆愛，結分投所欽。\n銜恩篤守義，萬里託微心。\n【其五】\n遊目四野外，逍遙獨延佇。\n蘭蕙緣清渠，繁華蔭綠渚。\n佳人不在茲，取此欲誰與。\n巢居知風寒，穴處識陰雨。\n不曾遠別離，安知慕儔侶。',
  },
  {
    id: 'poem-weijin-qingbaopian',
    category: 'poem',
    dynasty: 'weijin',
    title: '輕薄篇',
    source: '張華',
    description: '魏晉南北朝時期經典詩歌，作者為張華。',
    content: '末世多輕薄，驕代好浮華。\n志意既放逸，貲財亦豐奢。\n被服極纖麗，餚膳盡柔嘉。\n僮僕餘梁肉，婢妾蹈綾羅。\n文軒樹羽蓋，乘馬鳴玉珂。\n橫簪刻玳瑁，長鞭錯象牙。\n足下金鑮履，手中雙莫邪。\n賓從煥絡繹，侍御何芬葩。\n朝與金張期，暮宿許史家。\n甲笫面長街，朱門赫嵯峨。\n蒼梧竹葉青，宜城九醞醝。\n浮醪隨觴轉，素蟻自跳波。\n美女興齊趙，妍唱出西巴。\n一顧傾城國，千金不足多。\n北里獻奇舞，大陵奏名歌。\n新聲逾激楚，妙妓絕陽阿。\n玄鶴降浮雲，鱏魚躍中河。\n墨翟且停車，展季猶諮嗟。\n淳于前行酒，雍門坐相和。\n孟公結重關，賓客不得蹉。\n三雅來何遲？耳熱眼中花。\n盤案互交錯，坐席鹹喧譁。\n簪珥或墮落，冠冕皆傾斜。\n酣飲終日夜，明燈繼朝霞。\n絕纓尚不尤，安能復顧他？\n留連彌信宿，此歡難可過。\n人生若浮寄，年時忽蹉跎。\n促促朝露期，榮樂遽幾何？\n念此腸中悲，涕下自滂沱。\n但畏執法吏，禮防且切蹉。',
  },
  {
    id: 'poem-weijin-xingyingshensanshou',
    category: 'poem',
    dynasty: 'weijin',
    title: '形影神三首',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '【形贈影】\n天地長不沒，山川無改時。\n草木得常理，霜露榮悴之。\n謂人最靈智，獨復不如茲。\n適見在世中，奄去靡歸期。\n奚覺無一人，親識豈相思。\n但餘平生物，舉目情悽洏。\n我無騰化術，必爾不復疑。\n願君取吾言，得酒莫苟辭。\n【影答形】\n存生不可言，衛生每苦拙。\n誠願遊昆華，邈然茲道絕。\n與子相遇來，未嘗異悲悅。\n憩蔭若暫乖，止日終不別。\n此同既難常，黯爾俱時滅。\n身沒名亦盡，念之五情熱。\n立善有遺愛，胡爲不自竭？\n酒雲能消憂，方此詎不劣！\n【神釋】\n大鈞無私力，萬理自森著。\n人爲三才中，豈不以我故。\n與君雖異物，生而相依附。\n結托既喜同，安得不相語。\n三皇大聖人，今覆在何處？\n彭祖愛永年，欲留不得住。\n老少同一死，賢愚無複數。\n日醉或能忘，將非促齡具？\n立善常所欣，誰當爲汝譽？\n甚念傷吾生，正宜委運去。\n縱浪大化中，不喜亦不懼。\n應盡便須盡，無復獨多慮。',
  },
  {
    id: 'poem-weijin-weiguyanxianzengfuwangfanshisishou',
    category: 'poem',
    dynasty: 'weijin',
    title: '爲顧彥先贈婦往返詩四首',
    source: '陸雲',
    description: '魏晉南北朝時期經典詩歌，作者為陸雲。',
    content: '【其一】\n我在三川陽，子居五湖陰。\n山海一何曠，譬彼飛與沈。\n目想清惠姿，耳存淑媚音。\n獨寐多遠念，寤言撫空衿。\n彼美同懷子，非爾誰爲心。\n【其二】\n悠悠君行邁，煢煢妾獨止。\n山河安可逾，永路隔萬里。\n京師多妖冶，粲粲都人子。\n雅步嫋纖腰，巧笑發皓齒。\n佳麗良可美，衰賤焉足紀。\n遠蒙眷顧言，銜恩非望始。\n【其三】\n翩翩飛蓬徵，鬱郁寒木榮。\n遊止固殊性，浮沉豈一情。\n隆愛結在昔，信誓貫三靈。\n秉心金石固，豈從時俗傾。\n美目逝不顧，纖腰徒盈盈。\n何用結中款，仰指北辰星。\n【其四】\n浮海難爲水，遊林難爲觀。\n容色貴及時，朝華忌日晏。\n皎皎彼姝子，灼灼懷春粲。\n西城善稚舞，總章饒清彈。\n鳴簧發丹脣，朱弦繞素腕。\n輕裾猶電揮，雙袂如霞散。\n華容溢藻幄，哀響入雲漢。\n知音世所希，非君誰能贊。\n棄置北辰星，問此玄龍煥。\n時暮復何言，華落理必賤。',
  },
  {
    id: 'poem-weijin-jiaonshi',
    category: 'poem',
    dynasty: 'weijin',
    title: '嬌女詩',
    source: '左思',
    description: '魏晉南北朝時期經典詩歌，作者為左思。',
    content: '吾家有嬌女，皎皎頗白晰。\n小字爲紈素，口齒自清歷。\n鬢髮覆廣額，雙耳似連璧。\n明朝弄梳臺，黛眉類掃跡。\n濃朱衍丹脣，黃吻瀾漫赤。\n嬌語若連瑣，忿速乃明㦎。\n握筆利彤管，篆刻未期益。\n執書愛綈素，誦習矜所獲。\n其姊字惠芳，面目粲如畫。\n輕妝喜樓邊，臨鏡忘紡績。\n舉觶擬京兆，立的成復易。\n玩弄媚頰間，劇兼機杼役。\n從容好趙舞，延袖像飛翮。\n上下弦柱際，文史輒卷襞。\n顧眄屏風畫，如見已指摘。\n丹青日塵暗，明義爲隱頤。\n馳騖翔園林，果下皆生摘。\n紅葩棳紫蒂，萍實驟抵擲。\n貪華風雨中，倏忽數百適。\n務躡霜雪戲，重綦常累積。\n並心注餚饌，端坐理盤槅。\n翰墨戢閒按，相與數離逖。\n動爲壚鉦屈，屣履任之適。\n止爲荼菽據，吹噓對鼎䥶。\n脂膩漫白袖，煙燻染阿錫。\n衣被皆重地，難與沉水碧。\n任其孺子意，羞受長者責。\n瞥聞當與杖，掩淚俱向壁。',
  },
  {
    id: 'poem-weijin-daolizengmeishiershouyi',
    category: 'poem',
    dynasty: 'weijin',
    title: '悼離贈妹詩二首 一',
    source: '左思',
    description: '魏晉南北朝時期經典詩歌，作者為左思。',
    content: '鬱郁岱青。\n海瀆所經。\n陰精神靈。\n爲祥爲禎。\n峨峨令妹。\n應期挺生。\n如蘭之秀。\n如芝之榮。\n總角岐嶷。\n齠齔夙成。\n比德古烈。\n異世同聲。\n厥德伊何。\n塞淵其慮。\n厥聲伊何。\n日新其譽。\n幽思泉湧。\n乃詩乃賦。\n飛翰雲浮。\n摛藻星布。\n光曜邦族。\n名馳時路。\n翼翼羣媛。\n是瞻是慕。\n匪惟見慕。\n善誘善導。\n斟酌諸姬。\n言成典誥。\n匪唯辭章。\n多才多巧。\n黼黻文繡。\n幾微要妙。\n積德彌高。\n用心彌奧。\n伊我之闇。\n晞妹之曜。\n惟我惟妹。\n寔惟同生。\n早喪先妣。\n恩百常情。\n女子有行。\n實遠父兄。\n骨肉之思。\n固有歸寧。\n何悟離拆。\n隔以天庭。\n自我不見。\n於今二齡。\n豈唯二齡。\n相見未克。\n雖同京宇。\n殊邈異國。\n越鳥巢南。\n胡馬仰北。\n自然之戀。\n禽獸罔革。\n仰瞻參商。\n沉憂內塞。\n何以抒懷。\n告情翰墨。',
  },
  {
    id: 'poem-weijin-qiuhuxingqier',
    category: 'poem',
    dynasty: 'weijin',
    title: '秋胡行 其二',
    source: '曹操',
    description: '三國魏曹操四言/五言樂府詩名篇，展現慷慨悲涼之英雄氣概。',
    content: '願登泰華山，神人共遠遊。\n願登泰華山，神人共遠遊。\n經歷崑崙山，到蓬萊。\n飄遙八極，與神人俱。\n思得神藥，萬歲爲期。\n歌以言志，願登泰華山。\n天地何長久！人道居之短。\n天地何長久！人道居之短。\n世言伯陽，殊不知老；\n赤松王喬，亦云得道。\n得之未聞，庶以壽考。\n歌以言志，天地何長久！\n明明日月光，何所不光昭！\n明明日月光，何所不光昭！\n二儀合聖化，貴者獨人不？\n萬國率土，莫非王臣。\n仁義爲名，禮樂爲榮。\n歌以言志，明明日月關。\n四時更逝去，晝夜以成歲。\n四時更逝去，晝夜以成歲。\n大人先天而天弗違。\n不戚年往，憂世不治。\n存亡有命，慮之爲蚩。\n歌以言志，四時更逝去。\n慼慼欲何念！歡笑意所之。\n慼慼欲何念！歡笑意所之。\n壯盛智愚，殊不再來。\n愛時進趣，將以惠誰？\n泛泛放逸，亦同何爲！\n歌以言志，慼慼欲何念！',
  },
  {
    id: 'poem-weijin-zengzhengmanjishisishougufeng',
    category: 'poem',
    dynasty: 'weijin',
    title: '贈鄭曼季詩四首·穀風',
    source: '陸雲',
    description: '魏晉南北朝時期經典詩歌，作者為陸雲。',
    content: '習習穀風，扇此暮春。\n玄澤墜潤，靈華煙熅。\n高山熾景，喬木興繁。\n蘭波清湧，芳滸增源。\n感物興想，念我懷人。\n習習穀風，載穆其音。\n流芳鼓物，清塵拂林。\n霖雨嘉播，有渰悽陰。\n歸鴻逝矣，玄鳥來吟。\n嗟我懷人，其居樂潛。\n明發有想，如結予心。\n習習穀風，以溫以涼。\n玄黃交泰，品物含章。\n潛介淵躍，飛鳥雲翔。\n嗟我懷人，在津之梁。\n明發有思，凌波褰裳。\n習習穀風，有集惟喬。\n嗟我懷人，於焉逍遙。\n鸞棲高岡，耳想雲韶。\n拊翼墜夕，和鳴興朝。\n我之思之，言懷其休。\n習習穀風，其音孔嘉。\n所謂伊人，在谷之阿。\n虎質山嘯，龍輝淵播。\n維南有箕，匪休其和。\n有捄天畢，戢爾滂沱。\n懿厥河漢，耽彼大華。\n明發有懷，我勞如何。',
  },
  {
    id: 'poem-weijin-zengzhengmanjishisishounanheng',
    category: 'poem',
    dynasty: 'weijin',
    title: '贈鄭曼季詩四首·南衡',
    source: '陸雲',
    description: '魏晉南北朝時期經典詩歌，作者為陸雲。',
    content: '南衡惟嶽，峻極昊蒼。\n瞻彼江湘，惟水泱泱。\n清和有合，俊乂以藏。\n天保定爾，茂以瓊光。\n景秀濛汜，穎逸扶桑。\n我之懷矣，休音峻揚。\n穆穆休音，有來肅雍。\n沈波湧奧，淵芳馥風。\n傃虛養恬，照日遺蹤。\n考槃遵渚，思樂潛龍。\n我之懷矣，寘爾華宮。\n和璧在山，荊林玉潤。\n之子於潛，清輝遠振。\n克稱輶德，作寶有晉。\n和聲在林，羽儀未變。\n我之懷矣，有客來信。\n風雲有作，應通山淵。\n清琴啓彈，宮商乘弦。\n類族知感，有命自天。\n夷叔希世，猶謂比肩。\n矧我與子，姤會斯年。\n我之懷居，其好纏綿。\n古人有言，詩以宣心。\n我之懷矣，在彼北林。\n北林何有，於煥斯文。\n瓊瑰非寶，尺牘成珍。\n豐華非妙，得意惟神。\n河魴登俎，遭逢清川。',
  },
  {
    id: 'poem-weijin-zengzhangyiyangshi',
    category: 'poem',
    dynasty: 'weijin',
    title: '贈張弋陽詩',
    source: '張翰',
    description: '魏晉南北朝時期經典詩歌，作者為張翰。',
    content: '時道玄曠，階軌難尋。\n散纓放冕，負劍長吟。\n昆弟等志，託茲幽林。\n玄墨澄氣，虛靜和心。\n惟我友愛，纏綿往昔。\n易尚去俗，攜手林薄。\n輕露給朝，遺英飽夕。\n逍遙永日，何求何索。\n潛光重陰，抱悴如榮。\n絕路既續，舍我遐徵。\n朿帶皇域，升降都城。\n爰賴爰慕，忡予中情。\n負薪弗克，耕者妨力。\n仲儀彈弦，顧瞻先職。\n遺其綿綿，憂心慘惻。\n乃抗乃拔，釋我繞邑。\n將逝命駕，陟彼郊圻。\n和鸞搖響，載驅載馳。\n言告分別，言告言歸。\n心怨辭苦，張高弦哀。\n楊柳可卷，去在斯時。\n流液可年，豈雲旋歸。\n行役必偕，傷我長離。\n借喻孤禽，矜翼翩棲。\n昔我惟樂，羣居多跱。\n今我斯懷，纏綿萬里。\n人亦有分，或通或否。\n行矣免致，我誠永已。',
  },
  {
    id: 'poem-weijin-niwangecisanshou',
    category: 'poem',
    dynasty: 'weijin',
    title: '擬輓歌辭三首',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '【其一】\n有生必有死，早終非命促。\n昨暮同爲人，今旦在鬼錄。\n魂氣散何之，枯形寄空木。\n嬌兒索父啼，良友撫我哭。\n得失不復知，是非安能覺！\n千秋萬歲後，誰知榮與辱？\n但恨在世時，飲酒不得足。\n【其二】\n在昔無酒飲，今但湛空觴。\n春醪生浮蟻，何時更能嘗！\n餚案盈我前，親舊哭我傍。\n欲語口無音，欲視眼無光。\n昔在高堂寢，今宿荒草鄉；\n一朝出門去，歸來良未央。\n【其三】\n荒草何茫茫，白楊亦蕭蕭。\n嚴霜九月中，送我出遠郊。\n四面無人居，高墳正嶕嶢。\n馬爲仰天鳴，風爲自蕭條。\n幽室一已閉，千年不復朝。\n千年不復朝，賢達無奈何。\n向來相送人，各自還其家。\n親戚或餘悲，他人亦已歌。\n死去何所道，託體同山阿。',
  },
  {
    id: 'poem-weijin-qiuhuxingqiyi',
    category: 'poem',
    dynasty: 'weijin',
    title: '秋胡行 其一',
    source: '曹操',
    description: '三國魏曹操四言/五言樂府詩名篇，展現慷慨悲涼之英雄氣概。',
    content: '晨上散關山，此道當何難！\n晨上散關山，此道當何難！\n牛頓不起，車墮谷間。\n坐磐石之上，彈五絃之琴。\n作爲清角韻，意中迷煩。\n歌以言志，晨上散關山。\n有何三老公，卒來在我旁？\n有何三老公，卒來在我旁？\n負揜被裘，似非恆人。\n謂卿雲何困苦以自怨，徨徨所欲，來到此間？\n歌以言志，有何三老公？\n我居崑崙山，所謂者真人。\n我居崑崙山，所謂者真人。\n道深有可得。\n名山歷觀，遨遊八極，枕石漱流飲泉。\n沈吟不決，遂上升天。\n歌以言志，我居崑崙山。\n去去不可追，長恨相牽攀。\n去去不可追，長恨相牽攀。\n夜夜安得寐，惆悵以自憐。\n正而不譎，辭賦依因。\n經傳所過，西來所傳。\n歌以言志，去去不可追。',
  },
  {
    id: 'poem-weijin-qinnxiuxing',
    category: 'poem',
    dynasty: 'weijin',
    title: '秦女休行',
    source: '傅玄',
    description: '魏晉南北朝時期經典詩歌，作者為傅玄。',
    content: '龐氏有烈婦。義聲馳雍涼。父母家有重怨。仇人暴且強。\n雖有男兄弟。志弱不能當。烈女念此痛。丹心爲寸傷。\n外若無意者。內潛思無方。白日入都市。怨家如平常。\n匿劍藏白刃。一奮尋身僵。身首爲之異處。伏屍列肆旁。\n肉與土合成泥。灑血濺飛樑。猛氣上幹雲霓。仇黨失守爲披攘。\n一市稱烈義。觀者收淚並慨慷。百男何當益。不如一女良。\n烈女直造縣門。雲父不幸遭禍殃。今仇身以分裂。雖死情益揚。\n殺人當伏法。義不苟活隳舊章。縣令解印綬。令我傷心不忍聽。\n刑部垂頭塞耳。令我吏舉不能成。烈著希代之績。義立無窮之名。\n夫家同受共祚。子子孫孫鹹享其榮。今我作歌詠高風。激揚壯發悲且清。',
  },
  {
    id: 'poem-weijin-zengzhengmanjishisishouminghe',
    category: 'poem',
    dynasty: 'weijin',
    title: '贈鄭曼季詩四首·鳴鶴',
    source: '陸雲',
    description: '魏晉南北朝時期經典詩歌，作者為陸雲。',
    content: '鳴鶴在陰，戢其左翼。\n肅雍和鳴，在川之域。\n假樂君子，祚爾明德。\n思樂重虛，歸於其極。\n嗟我懷人，惟馨黍稷。\n鳴鶴在陰，其鳴喈喈。\n垂翼蘭沼，濯清芳池。\n假樂君子，其茂猗猗。\n底之瑰寶，有粲瓊環。\n乃振褧裳，襲爾好衣。\n嗟我懷人，啓襟以晞。\n鳴鶴在陰，其儀藹藹。\n謂天蓋高，和音於邁。\n假樂君子，篤膺俊乂。\n穆風潛烈，興雲戢薈。\n德茂當年，時愆嘉會。\n安德鞶藻，改爾縞帶。\n嗟我懷人，心焉慷愾。\n鳴鶴在陰，載好其聲。\n漸陸儀羽，遵渚回涇。\n假樂君子，祚之篤生。\n德耀有穆，如瑤如瓊。\n視流濯發，滅景遺纓。\n安得風雲，雨爾北冥。\n嗟我懷人，惟用傷情。',
  },
  {
    id: 'poem-weijin-zashisanshou',
    category: 'poem',
    dynasty: 'weijin',
    title: '雜詩三首',
    source: '張華',
    description: '魏晉南北朝時期經典詩歌，作者為張華。',
    content: '【其一】\n晷度隨天運，四時互相承。\n東壁正昏中，涸陰寒節升。\n繁霜降當夕，悲風中夜興。\n朱火青無光，蘭膏坐自凝。\n重衾無暖氣，挾纊如懷冰。\n伏枕終遙昔，寤言莫予應。\n永思慮崇替，慨然獨拊膺。\n【其二】\n逍遙遊春宮，容與緣池阿。\n白蘋齊素葉，朱草茂丹華。\n微風搖蕖若，層波動芰荷。\n榮彩曜中林，流馨入綺羅。\n王孫遊不歸，修路邈以遐。\n誰與玩遺芳，佇立獨諮嗟。\n【其三】\n荏苒日月運，寒暑忽流易。\n同好逝不存，迢迢遠離析。\n房櫳自來風，戶庭無行跡。\n蒹葭生牀下，蛛蝥網四壁。\n懷思見不隆，感物重鬱積。\n遊雁比翼翔，歸鴻知接翮。\n來哉彼君子，無然徒自隔。',
  },
  {
    id: 'poem-weijin-dajiajiuzhouchou',
    category: 'poem',
    dynasty: 'weijin',
    title: '答賈九州愁',
    source: '郭璞',
    description: '魏晉南北朝時期經典詩歌，作者為郭璞。',
    content: '廣莫戒寒，玄英啓謝。\n感彼時變，悲此物化。\n獨步閒朝，哀嘆靜夜。\n德非顏原，屢空蓬舍。\n輕服御冬，藍褐當夏。\n正未墨突，逝將命駕。\n幸賴吾賢，少以慰藉。\n顧瞻中宇，一朝分崩。\n天網既紊，浮鯢橫騰。\n運首北眷，邈哉華恆。\n雖欲凌翥，矯翮靡登。\n俯懼潛機，仰慮飛罾。\n惟其嶮哀，難辛備曾。\n庶睎河清，混焉未澄。\n自我徂遷，周之陽月。\n亂離方焮，憂虞匪歇。\n四極雖遙，息駕靡脫。\n願言齊衡，庶幾契闊。\n雖雲暗投，圭璋特達。\n綿駒之變，何有胡越。\n子固喬楚，我伊羅葛。\n無貴香明，終自㵶渴。\n未若遺榮，閟情丘壑。\n逍遊永年，抽簪收發。',
  },
  {
    id: 'poem-weijin-zenglujichuweiwuwanglangzhonglingshi',
    category: 'poem',
    dynasty: 'weijin',
    title: '贈陸機出爲吳王郎中令詩',
    source: '潘尼',
    description: '魏晉南北朝時期經典詩歌，作者為潘尼。',
    content: '東南之美，曩惟延州。\n顯允陸生，於今尠儔。\n振鱗南海，濯翼清流。\n婆娑翰林，容與墳丘。\n玉以瑜潤，隨以光融。\n乃漸上京，羽儀儲宮。\n玩爾清藻，味爾芳風。\n泳之彌廣，挹之彌衝。\n崑山何有，有瑤有珉。\n及爾同僚，具惟近臣。\n予涉素秋，子登青春。\n愧無老成，廁彼日新。\n祁祁大邦，惟桑惟梓。\n穆穆伊人，南國之紀。\n帝曰爾諧，惟王卿士。\n俯樓從命，奚恤奚喜。\n我車既巾，我馬既秣。\n星陳夙駕，載脂載轄。\n婉孌二宮，徘徊殿闥。\n醪澄莫饗，孰慰飢渴。\n昔子忝私，貽我蕙蘭。\n今子徂東，何以贈旃。\n寸晷惟寶，豈無璵璠。\n彼美陸生，可與晤言。',
  },
  {
    id: 'poem-weijin-qiuhuxing',
    category: 'poem',
    dynasty: 'weijin',
    title: '秋胡行',
    source: '傅玄',
    description: '魏晉南北朝時期經典詩歌，作者為傅玄。',
    content: '秋胡納令室，三日宦他鄉。\n皎皎潔婦姿，泠泠守空房。\n燕婉不終夕，別如參與商。\n憂來猶四海，易感難可防。\n人言生日短，愁者苦夜長。\n百草揚春華，攘腕採柔桑。\n素手尋繁枝，落葉不盈筐。\n羅衣翳玉體，回目流採章。\n君子倦仕歸，車馬如龍驤。\n精誠馳萬里，既至兩相忘。\n行人悅令顏，借息此樹旁。\n誘以逢卿喻，遂下黃金裝。\n烈烈貞女忿，言辭厲秋霜。\n長驅及居室，奉金升北堂。\n母立呼婦來，歡樂情未央。\n秋胡見此婦，惕然懷探湯。\n負心豈不慚，永誓非所望。\n清濁自異源，鳧鳳不併翔。\n引身赴長流，果哉潔婦腸！\n彼夫既不淑，此婦亦太剛。',
  },
  {
    id: 'poem-weijin-shanshanghuazan',
    category: 'poem',
    dynasty: 'weijin',
    title: '扇上畫贊',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '三五道邈，淳風日盡。九流參差，互相推隕。\n形逐物遷，心無常準。是以達人，有時而隱。\n“四體不勤，五穀不分”，超超丈人，日夕在耘。\n遼遼沮溺，耦耕自欣，入鳥不駭，雜獸斯羣。\n至矣於陵，養氣浩然，蔑彼結駟，甘此灌園。\n張生一仕，曾以事還，顧我不能，高謝人間。\n岧岧丙公，望崖輒歸，匪驕匪吝，前路威夷。\n鄭叟不合，垂釣川湄，交酌林下，清言究微。\n孟嘗遊學，天網時疏，眷言哲友，振褐偕徂。\n美哉周子，稱疾閒居，寄心清尚，悠然自娛。\n翳翳衡門，洋洋泌流，曰琴曰書，顧盼有儔。\n飲河既足，自外皆休。緬懷千載，託契孤遊。',
  },
  {
    id: 'poem-weijin-qichuchangqier',
    category: 'poem',
    dynasty: 'weijin',
    title: '氣出唱 其二',
    source: '曹操',
    description: '三國魏曹操四言/五言樂府詩名篇，展現慷慨悲涼之英雄氣概。',
    content: '駕六龍，乘風而行。\n行四海，路下之八邦。\n歷登高山臨溪谷，乘雲而行。\n行四海外，東到泰山。\n仙人玉女，下來翱遊。\n驂駕六龍飲玉漿。\n河水盡，不東流。\n解愁腹，飲玉漿。\n奉持行，東到蓬萊山，上至天之門。\n玉闕下，引見得入，\n赤松相對，四面顧望，視正焜煌。\n開玉心正興，其氣百道至。\n傳告無窮閉其口，但當愛氣壽萬年。\n東到海，與天連。\n神仙之道，出窈入冥，常當專之。\n心恬澹，無所愒。\n欲閉門坐自守，天與期氣。\n願得神之人，乘駕雲車，\n驂駕白鹿，上到天之門，來賜神之藥。\n跪受之，敬神齊。\n當如此，道自來。',
  },
  {
    id: 'poem-weijin-dapangcanjunhengmenzhixia',
    category: 'poem',
    dynasty: 'weijin',
    title: '答龐參軍·衡門之下',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '衡門之下，有琴有書。載彈載詠，爰得我娛。\n豈無他好，樂是幽居。朝爲灌園，夕偃蓬廬。\n人之所寶，尚或未珍。不有同好，雲胡以親？\n我求良友，實覯懷人。歡心孔洽，棟宇惟鄰。\n伊餘懷人，欣德孜孜。我有旨酒，與汝樂之。\n乃陳好言，乃著新詩。一日不見，如何不思。\n嘉遊未斁，誓將離分。送爾於路，銜觴無欣。\n依依舊楚，邈邈西雲。之子之遠，良話曷聞。\n昔我雲別，倉庚載鳴。今也遇之，霰雪飄零。\n大藩有命，作使上京。豈忘宴安，王事靡寧。\n慘慘寒日，肅肅其風。翩彼方舟，容裔江中。\n勗哉徵人，在始思終。敬茲良辰，以保爾躬。',
  },
  {
    id: 'poem-weijin-weiyangchangwenzuodizhongwuaizhuwen',
    category: 'poem',
    dynasty: 'weijin',
    title: '爲楊長文作弟仲武哀祝文',
    source: '潘岳',
    description: '魏晉南北朝時期經典詩歌，作者為潘岳。',
    content: '悠悠上天，我獨何辜。\n祖考早世，昆弟幼孤。\n備嘗艱毒，同集蓼荼。\n父兮生我，過庭靡聞。\n母兮鞠我，寧一苦卒。\n日顧日復，我弟我身。\n並自垂髮，越於成人。\n浚哲聰朗，純粹溫良。\n烈烈清風，邦族之望。\n母氏劬勞，庶爾之報。\n彼蒼者天，子何不弔。\n殲我令弟，窮泉是造。\n無父何怙，無弟何友。\n煢煢此身，哀哀慈母。\n煩冤痛毒，撫心思咎。\n哀爾薄佑，逢家多阻。\n弱冠未室，盛年絕緒。\n喪庭寥廓，盧位無主。\n冥冥長夜，窈窕玄宇。\n當復何時，見我仲武。\n於以祔之，於其王父。\n魂而有靈，神其寧處。',
  },
  {
    id: 'poem-weijin-duangexingqier',
    category: 'poem',
    dynasty: 'weijin',
    title: '短歌行 其二',
    source: '曹操',
    description: '三國魏曹操四言/五言樂府詩名篇，展現慷慨悲涼之英雄氣概。',
    content: '周西伯昌，懷此聖德。\n三分天下，而有其二。\n修奉貢獻，臣節不隆。\n崇侯讒之，是以拘繫。\n後見赦原，賜之斧鉞，得使征伐。\n爲仲尼所稱，達及德行，\n猶奉事殷，論敘其美。\n齊桓之功，爲霸之首。\n九合諸侯，一匡天下。\n一匡天下，不以兵車。\n正而不譎，其德傳稱。\n孔子所嘆，並稱夷吾，民受其恩。\n賜與廟胙，命無下拜。\n小白不敢爾，天威在顏咫尺。\n晉文亦霸，躬奉天王。\n受賜圭瓚，秬鬯彤弓，\n盧弓矢千，虎賁三百人。\n威服諸侯，師之所尊。\n八方聞之，名亞齊桓。\n河陽之會，詐稱周王，是其名紛葩。',
  },
  {
    id: 'poem-weijin-fufengge',
    category: 'poem',
    dynasty: 'weijin',
    title: '扶風歌',
    source: '劉琨',
    description: '魏晉南北朝時期經典詩歌，作者為劉琨。',
    content: '朝發廣莫門，暮宿丹水山。\n左手彎繁弱，右手揮龍淵。\n顧瞻望宮闕，俯仰御飛軒。\n據鞍長嘆息，淚下如流泉。\n繫馬長松下，廢鞍高嶽頭。\n烈烈悲風起，泠泠澗水流。\n揮手長水流，揮手長相謝。\n哽咽不能言，浮雲爲我結。\n歸鳥爲我旋，去家日已遠。\n安知存與亡，慷慨窮林中。\n抱膝獨摧藏，麋鹿遊我前。\n猨猴戲我側，資糧既乏盡。\n薇蕨安可食，攬轡命徒侶。\n吟嘯絕巖中，君子道微矣。\n夫子故有窮，惟昔李騫期。\n寄在匈奴庭，忠信反獲罪。\n漢武不見明，我欲竟此曲。\n此曲悲且長，棄置勿重陳。\n重陳令心傷。',
  },
  {
    id: 'poem-weijin-wuquxing',
    category: 'poem',
    dynasty: 'weijin',
    title: '吳趨行',
    source: '陸機',
    description: '魏晉南北朝時期經典詩歌，作者為陸機。',
    content: '楚妃且勿嘆，齊娥且莫謳。\n四坐並清聽，聽我歌吳趨。\n吳趨自有始，請從閶門起。\n閶門何峨峨，飛閣跨通波。\n重欒承遊極，回軒啓曲阿。\n藹藹慶雲被，泠泠鮮風通。\n山澤多藏育，土風清且嘉。\n泰伯導仁風，仲雍揚其波。\n穆穆延陵子，灼灼光諸華。\n王跡隤陽九，帝功興四遐。\n大皇自富春，矯手頓世羅。\n邦彥應運興，粲若春林葩。\n屬城鹹有士，吳邑最爲多。\n八族未足侈，四姓實名家。\n文德熙淳懿，武功侔山河。\n禮讓何濟濟，流化自滂沱。\n淑美難窮紀，商榷爲此歌。',
  },
  {
    id: 'poem-weijin-neigushiershou',
    category: 'poem',
    dynasty: 'weijin',
    title: '內顧詩二首',
    source: '潘岳',
    description: '魏晉南北朝時期經典詩歌，作者為潘岳。',
    content: '【其一】\n靜居懷所歡，登城望四澤。\n春草鬱青青，桑柘何奕奕。\n芳林振朱榮，淥水激素石。\n初征冰未泮，忽焉振絺綌。\n漫漫三千里，迢迢遠行客。\n馳情戀朱顏，寸陰過盈尺。\n夜愁極清晨，朝悲終日夕。\n山川信悠永，願言良弗獲。\n引領訊歸雲，沉思不可釋。\n【其二】\n獨悲安所慕，人生若朝露。\n綿邈寄絕域，眷戀想平素。\n爾情既來追，我心亦還顧。\n形體隔不達，精爽交中路。\n不見山上松，隆冬不易故。\n不見陵澗柏，歲寒守一度。\n無謂希見疏，在遠分彌固。',
  },
  {
    id: 'poem-weijin-jinglinggongzhunwangshiaici',
    category: 'poem',
    dynasty: 'weijin',
    title: '京陵公主女王氏哀辭',
    source: '潘岳',
    description: '魏晉南北朝時期經典詩歌，作者為潘岳。',
    content: '猗歟公子，季女惟王。\n生自洪胄，稟茲義方。\n盻倩粲麗，窈窕淑良。\n如彼春蘭，吐葩含芳。\n葩以霜隕，芳以歇盡。\n彼蒼者天，胡寧斯忍。\n曾未弱笄，無疾而隕。\n官朝震驚，靡人不愍。\n嗟爾母氏，劬勞撫鞠。\n恩斯勤斯，是長是育。\n帷屏媚子，奄離顧復。\n哀無廢心，涕不輟目。\n於以祖之，於掖庭閨。\n於以送之，陵崗崔嵬。\n僕馬回春，旗旐旋飛。\n夕陽失映，晴鳥忘歸。\n皎皎霄月，載盈載微。\n冥冥公子，一往不追。\n長夜無旦，孤魂曷依。',
  },
  {
    id: 'poem-weijin-taohuayuanshi',
    category: 'poem',
    dynasty: 'weijin',
    title: '桃花源詩',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '嬴氏亂天紀，賢者避其世。\n黃綺之商山，伊人亦云逝。\n往跡浸復湮，來徑遂蕪廢。\n相命肆農耕，日入從所憩。\n桑竹垂餘蔭，菽稷隨時藝；\n春蠶收長絲，秋熟靡王稅。\n荒路曖交通，雞犬互鳴吠。\n俎豆猶古法，衣裳無新制。\n童孺縱行歌，班白歡遊詣。\n草榮識節和，木衰知風厲。\n雖無紀曆志，四時自成歲。\n怡然有餘樂，於何勞智慧？\n奇蹤隱五百，一朝敞神界。\n淳薄既異源，旋復還幽蔽。\n借問遊方士，焉測塵囂外。\n願言躡清風，高舉尋吾契。',
  },
  {
    id: 'poem-weijin-guimaosuishichunhuaigutiansheershou',
    category: 'poem',
    dynasty: 'weijin',
    title: '癸卯歲始春懷古田舍二首',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '【其一】\n在昔聞南畝，當年竟未踐。\n屢空既有人，春興豈自免？\n夙晨裝吾駕，啓塗情已緬。\n鳥哢歡新節，泠風送餘善。\n寒草被荒蹊，地爲罕人遠。\n是以植杖翁，悠然不復返。\n即理愧通識，所保詎乃淺。\n【其二】\n先師有遺訓，憂道不憂貧。\n瞻望邈難逮，轉欲志長勤。\n秉耒歡時務，解顏勸農人。\n平疇交遠風，良苗亦懷新。\n雖未量歲功，既事多所欣。\n耕種有時息，行者無問津。\n日入相與歸，壺漿勞近鄰。\n長吟掩柴門，聊爲隴畝民。',
  },
  {
    id: 'poem-weijin-weirenzixianqizuogunzelanaici',
    category: 'poem',
    dynasty: 'weijin',
    title: '爲任子鹹妻作孤女澤蘭哀辭',
    source: '潘岳',
    description: '魏晉南北朝時期經典詩歌，作者為潘岳。',
    content: '茫茫造化，爰啓英淑。\n猗猗澤蘭，應靈誕育。\n鬒髮蛾眉，巧笑美目。\n顏耀榮苕，華茂時菊。\n如金之精，如蘭之馨。\n淑質彌暢，聰慧日新。\n朝夕顧復，夙夜盡勤。\n彼蒼者天，哀此矜人。\n胡寧不惠，忍予眇身。\n俾爾嬰孺，微命弗振。\n俯覽衾邃，仰訴穹旻。\n弱子在懷，既生不遂。\n存靡託躬，沒無遺類。\n耳存遺響，目想餘顏。\n寢席伏枕，摧心割肝。\n相彼鳥矣。和鳴嚶嚶。\n矧伊蘭子，音影冥冥。\n彷徨丘隴，徒倚墳塋。',
  },
  {
    id: 'poem-weijin-duangexingqiyi',
    category: 'poem',
    dynasty: 'weijin',
    title: '短歌行 其一',
    source: '曹操',
    description: '三國魏曹操四言/五言樂府詩名篇，展現慷慨悲涼之英雄氣概。',
    content: '對酒當歌，人生幾何！譬如朝露，去日苦多。\n慨當以慷，憂思難忘。何以解憂？唯有杜康。\n青青子衿，悠悠我心。但爲君故，沉吟至今。\n呦呦鹿鳴，食野之苹。我有嘉賓，鼓瑟吹笙。\n明明如月，何時可掇？憂從中來，不可斷絕。(明明 一作：佼佼)\n越陌度阡，枉用相存。契闊談讌，心念舊恩。(談讌 一作：談宴)\n月明星稀，烏鵲南飛。繞樹三匝，何枝可依？\n山不厭高，海不厭深。周公吐哺，天下歸心。(海 一作：水)',
  },
  {
    id: 'poem-weijin-tingyunshi',
    category: 'poem',
    dynasty: 'weijin',
    title: '停雲詩',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '【其一】\n靄靄停雲，濛濛時雨。\n八表同昏，平路伊阻。\n靜寄東軒，春醪獨撫。\n良朋悠邈，搔首延佇。\n【其二】\n停雲靄靄，時雨濛濛。\n八表同昏，平陸成江。\n有酒有酒，閒飲東窗。\n願言懷人，舟車靡從。\n【其三】\n東園之樹，枝條載榮。\n競用新好，以怡餘情。\n人亦有言：日月於徵。\n安得促席，說彼平生。\n【其四】\n翩翩飛鳥，息我庭柯。\n斂翮閒止，好聲相和。\n豈無他人，念子實多。\n願言不獲，抱恨如何！',
  },
  {
    id: 'poem-weijin-shiyun',
    category: 'poem',
    dynasty: 'weijin',
    title: '時運',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '【其一】\n邁邁時運，穆穆良朝。\n襲我春服，薄言東郊。\n山滌餘靄，宇曖微霄。\n有風自南，翼彼新苗。\n【其二】\n洋洋平澤，乃漱乃濯。\n邈邈遐景，載欣載矚。\n稱心而言，人亦易足。\n揮茲一觴，陶然自樂。\n【其三】\n延目中流，悠想清沂。\n童冠齊業，閒詠以歸。\n我愛其靜，寤寐交揮。\n但恨殊世，邈不可追。\n【其四】\n斯晨斯夕，言息其廬。\n花葯分列，林竹翳如。\n清琴橫牀，濁酒半壺。\n黃唐莫逮，慨獨在餘。',
  },
  {
    id: 'poem-weijin-zhongzengluchen',
    category: 'poem',
    dynasty: 'weijin',
    title: '重贈盧諶',
    source: '劉琨',
    description: '魏晉南北朝時期經典詩歌，作者為劉琨。',
    content: '握中有懸璧，本自荊山璆。\n惟彼太公望，昔在渭濱叟。\n鄧生何感激，千里來相求。\n白登幸曲逆，鴻門賴留侯。\n重耳任五賢，小白相射鉤。\n苟能隆二伯，安問黨與仇？\n中夜撫枕嘆，相與數子游。\n吾衰久矣夫，何其不夢周？\n誰雲聖達節，知命故不憂？\n宣尼悲獲麟，西狩涕孔丘。\n功業未及建，夕陽忽西流。\n時哉不我與，去乎若雲浮。\n朱實隕勁風，繁英落素秋。\n狹路傾華蓋，駭駟摧雙輈。\n何意百鍊剛，化爲繞指柔。',
  },
  {
    id: 'poem-weijin-younpian',
    category: 'poem',
    dynasty: 'weijin',
    title: '有女篇',
    source: '傅玄',
    description: '魏晉南北朝時期經典詩歌，作者為傅玄。',
    content: '有女懷芬芳，媞媞步東廂。\n蛾眉分翠羽，明目發清揚。\n丹脣醫皓齒，秀色若珪璋。\n巧笑露權靨，衆媚不可詳。\n令儀希世出，無乃古毛嬙。\n頭安金步搖，耳系明月璫。\n珠環約素腕，翠羽垂鮮光。\n文袍綴藻黼，玉體映羅裳。\n容華既已豔，志節擬秋霜。\n徽音冠青雲，聲響流四方。\n妙哉英媛德，宜配侯與王。\n靈應萬世合，日月時相望。\n媒氏陳束帛，羔雁鳴前堂。\n百兩盈中路，起若鸞鳳翔。\n凡夫徒踊躍，望絕殊參商。',
  },
  {
    id: 'poem-weijin-yongjingke',
    category: 'poem',
    dynasty: 'weijin',
    title: '詠荊軻',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '燕丹善養士，志在報強嬴。\n招集百夫良，歲暮得荊卿。\n君子死知己，提劍出燕京；\n素驥鳴廣陌，慷慨送我行。\n雄髮指危冠，猛氣衝長纓。\n飲餞易水上，四座列羣英。\n漸離擊悲筑，宋意唱高聲。\n蕭蕭哀風逝，淡淡寒波生。\n商音更流涕，羽奏壯士驚。\n心知去不歸，且有後世名。\n登車何時顧，飛蓋入秦庭。\n凌厲越萬里，逶迤過千城。\n圖窮事自至，豪主正怔營。\n惜哉劍術疏，奇功遂不成。\n其人雖已沒，千載有餘情。',
  },
  {
    id: 'poem-weijin-shujiu',
    category: 'poem',
    dynasty: 'weijin',
    title: '述酒',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '重離照南陸，鳴鳥聲相聞；\n秋草雖未黃，融風久已分。\n素礫皛修渚，南嶽無餘雲。\n豫章抗高門，重華固靈墳。\n流淚抱中嘆，傾耳聽司晨。\n神州獻嘉粟，西靈爲我馴。\n諸梁董師旅，芊勝喪其身。\n山陽歸下國，成名猶不勤。\n卜生善斯牧，安樂不爲君。\n平王去舊京，峽中納遺薰。\n雙陵甫雲育，三趾顯奇文。\n王子愛清吹，日中翔河汾。\n朱公練九齒，閒居離世紛。\n峨峨西嶺內，偃息常所親。\n天容自永固，彭殤非等倫。',
  },
  {
    id: 'poem-weijin-wangmingjun',
    category: 'poem',
    dynasty: 'weijin',
    title: '王明君',
    source: '石崇',
    description: '魏晉南北朝時期經典詩歌，作者為石崇。',
    content: '我本漢家子，將適單于庭。\n辭決未及終，前驅已抗旌。\n僕御涕流離，轅馬悲且鳴。\n哀鬱傷五內，泣淚沾朱纓。\n行行日已遠，遂造匈奴城。\n延我於穹廬，加我閼氏名。\n殊類非所安，雖貴非所榮。\n父子見陵辱，對之慚且驚。\n殺身良不易，默默以苟生。\n苟生亦何聊，積思常憤盈。\n願假飛鴻翼，棄之以遐徵。\n飛鴻不我顧，佇立以屏營。\n昔爲匣中玉，今爲糞上英。\n朝華不足歡，甘與秋草並。\n傳語後世人，遠嫁難爲情。',
  },
  {
    id: 'poem-weijin-zengzhengmanjishisishougaogang',
    category: 'poem',
    dynasty: 'weijin',
    title: '贈鄭曼季詩四首·高岡',
    source: '陸雲',
    description: '魏晉南北朝時期經典詩歌，作者為陸雲。',
    content: '瞻彼高岡，有猗其桐。\n允也君子，實寶南江。\n員規啓裕，沈矩履方。\n泳此明流，清瀾川通。\n陟彼衡林，味其回芳。\n馥矣回芳，綢繆中原。\n祁祁庶類，薄採其芬。\n棲遲泌丘，容與衡門。\n聲播東汜，響溢南雲。\n穆穆閶闔，南端啓籥。\n庶明以庸，帝聽式闕。\n有鳳於潛，在林棲翮。\n非予之祚，孰與好爵。\n幽居玩物，顧景自頤。\n發憤潛帷，彷彿有思。\n予美亡此，終然肯來。\n企予與言，惟用作詩（○同上）。',
  },
  {
    id: 'poem-weijin-gengzisuiwuyuezhongcongdouhuanzufengwuguilinershou',
    category: 'poem',
    dynasty: 'weijin',
    title: '庚子歲五月中從都還阻風於規林二首',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '【其一】\n行行循歸路，計日望舊居。\n一欣侍溫顏，再喜見友于。\n鼓棹路崎曲，指景限西隅。\n江山豈不險？歸子念前塗。\n凱風負我心，戢楪守窮湖。\n高莽眇無界，夏木獨森疏。\n誰言客舟遠？近瞻百里餘。\n延目識南嶺，空嘆將焉如！\n【其二】\n自古嘆行役，我今始知之。\n山川一何曠，巽坎難與期。\n崩浪聒天響，長風無息時。\n久遊戀所生，如何淹在茲。\n靜念園林好，人間良可辭。\n當年詎有幾？縱心復何疑！',
  },
  {
    id: 'poem-weijin-chaoshipian',
    category: 'poem',
    dynasty: 'weijin',
    title: '朝時篇',
    source: '傅玄',
    description: '魏晉南北朝時期經典詩歌，作者為傅玄。',
    content: '昭昭朝時日，皎皎晨明月。\n十五入君門，一別終華髮。\n同心忽異離，曠若胡與越。\n胡越有會時，參辰遼且闊。\n形影雖彷彿，音聲寂無達。\n纖弦感促柱，觸之哀聲發。\n情思如循環，憂來不可遏。\n塗山有餘恨，詩人詠采葛。\n蜻蛚吟牀下，迴風起幽闥。\n春榮隨露落，芙蓉生木末。\n自傷命不遇，良辰永乖別。\n已爾可奈何，譬如紈素裂。\n孤雌翔故巢，流星光景絕。\n魂神馳萬里，甘心要同穴。',
  },
  {
    id: 'poem-weijin-yangchengliushimeiaici',
    category: 'poem',
    dynasty: 'weijin',
    title: '陽城劉氏妹哀辭',
    source: '潘岳',
    description: '魏晉南北朝時期經典詩歌，作者為潘岳。',
    content: '鳥鳴於柏，鳥號於荊。\n徘徊以躅，立聞其聲。\n相彼羽族，矧伊人情。\n叩心長叫，痛我同生。\n誕育聖善，發奇稚齒。\n如彼名駒，昂昂千里。\n劉氏懷寶，未曜隋和。\n伊羽輕弱，弗克負荷。\n祿微於朝，貯匱於家。\n俾我令妹，勤儉備加。\n珍羞罕御，器服靡華。\n撫膺恨毒，逝矣奈何。\n哀哀母氏，蒸蒸聖慈。\n震動擗摽，何痛如之。\n魂而有靈，豈不慕思。\n嗟哉往矣，當復何時。',
  },
  {
    id: 'poem-weijin-rongmu',
    category: 'poem',
    dynasty: 'weijin',
    title: '榮木',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '采采榮木，結根於茲。\n晨耀其華，夕已喪之。\n人生若寄，憔悴有時。\n靜言孔念，中心悵而。\n采采榮木，於茲託根。\n繁華朝起，慨暮不存。\n貞脆由人，禍福無門。\n匪道曷依，匪善奚敦！\n嗟予小子，稟茲固陋。\n徂年既流，業不增舊。\n志彼不捨，安此日富。\n我之懷矣，怛焉內疚。\n先師遺訓，餘豈之墜。\n四十無聞，斯不足畏！\n脂我名車，策我名驥，\n千里雖遙，孰敢不至！',
  },
  {
    id: 'poem-weijin-zengchangshagongzuzu',
    category: 'poem',
    dynasty: 'weijin',
    title: '贈長沙公族祖',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '同源分流，人易世疏。\n慨然寤嘆，念茲厥初。\n禮服遂悠，歲月眇徂。\n感彼行路，眷然躊躇。\n於穆令族，允構斯堂。\n諧氣冬暄，映懷圭璋。\n爰採春花，載警秋霜。\n我曰欽哉，實宗之光。\n伊餘雲遘，在長忘同。\n笑言未久，逝焉西東。\n遙遙三湘，滔滔九江，\n山川阻遠，行李時通！\n何以寫心，貽此話言。\n進簣雖微，終焉爲山。\n敬哉離人，臨路悽然。\n款襟或遼，音問其先！',
  },
  {
    id: 'poem-weijin-duguanshan',
    category: 'poem',
    dynasty: 'weijin',
    title: '度關山',
    source: '曹操',
    description: '三國魏曹操四言/五言樂府詩名篇，展現慷慨悲涼之英雄氣概。',
    content: '天地間，人爲貴。\n立君牧民，爲之軌則。\n車轍馬跡，經緯四極。\n黜陟幽明，黎庶繁息。\n於鑠賢聖，總統邦域。\n封建五爵，井田刑獄。\n有燔丹書，無普赦贖。\n皋陶甫侯，何有失職？\n嗟哉後世，改制易律。\n勞民爲君，役賦其力。\n舜漆食器，畔者十國，\n不及唐堯，採椽不斫。\n世嘆伯夷，欲以厲俗。\n侈惡之大，儉爲共德。\n許由推讓，豈有訟曲？\n兼愛尚同，疏者爲戚。',
  },
  {
    id: 'poem-weijin-qichuchangqiyi',
    category: 'poem',
    dynasty: 'weijin',
    title: '氣出唱 其一',
    source: '曹操',
    description: '三國魏曹操四言/五言樂府詩名篇，展現慷慨悲涼之英雄氣概。',
    content: '華陰山，自以爲大。\n高百丈，浮雲爲之蓋。\n仙人慾來，出隨風，列之雨。\n吹我洞簫，鼓瑟琴，何誾誾！\n酒與歌戲，今日相樂誠爲樂。\n玉女起，起舞移數時。\n鼓吹一何嘈嘈。\n從西北來時，仙道多駕煙，\n乘雲駕龍，鬱何務務。\n遨遊八極，乃到崑崙之山，\n西王母側，神仙金止玉亭。\n來者爲誰？赤松王喬，乃德旋之門。\n樂共飲食到黃昏。\n多駕合坐，萬歲長，宜子孫。',
  },
  {
    id: 'poem-weijin-qixiguanzhinshi',
    category: 'poem',
    dynasty: 'weijin',
    title: '七夕觀織女詩',
    source: '王鑑',
    description: '魏晉南北朝時期經典詩歌，作者為王鑑。',
    content: '牽牛悲殊館，織女悼離家。\n一稔期一宵，此期良可嘉。\n赫奕玄門開，飛閣鬱嵯峨。\n隱隱驅千乘，闐闐越星河。\n六龍奮瑤轡，文螭負瓊車。\n火丹秉瑰燭，素女執瓊華。\n絳旗若吐電，朱蓋如振霞。\n雲韶何嘈嗷，靈鼓鳴相和。\n停軒紆高盻，眷予在岌峨。\n澤因芳露沾，恩附蘭風加。\n明發相從遊，翩翩鸞鷟羅。\n同遊不同觀，念子憂怨多。\n敬因三祝末，以爾屬皇娥。',
  },
  {
    id: 'poem-weijin-yuzhangxingkuxiangpian',
    category: 'poem',
    dynasty: 'weijin',
    title: '豫章行苦相篇',
    source: '傅玄',
    description: '魏晉南北朝時期經典詩歌，作者為傅玄。',
    content: '苦相身爲女，卑陋難再陳。\n男兒當門戶，墮地自生神。\n雄心志四海，萬里望風塵。\n女育無欣愛，不爲家所珍。\n長大逃深室，藏頭羞見人。\n垂淚適他鄉，忽如雨絕雲。\n低頭和顏色，素齒結朱脣。\n跪拜無複數，婢妾如嚴賓。\n情合同雲漢，葵藿仰陽春。\n心乖甚水火，百惡集其身。\n玉顏隨年變，丈夫多好新。\n昔爲形與影，今爲胡與秦。\n胡秦時相見，一絕逾參辰。',
  },
  {
    id: 'poem-weijin-guiniao',
    category: 'poem',
    dynasty: 'weijin',
    title: '歸鳥',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '翼翼歸鳥，晨去於林。遠之八表，近憩雲岑。\n和風不洽，翻翮求心。顧儔相鳴，景庇清陰。\n翼翼歸鳥，載翔載飛。雖不懷遊，見林情依。\n遇雲頡頏，相鳴而歸。遐路誠悠，性愛無遺。\n翼翼歸鳥，馴林徘徊。豈思天路，欣反舊棲。\n雖無昔侶，衆聲每諧。日夕氣清，悠然其懷。\n翼翼歸鳥，戢羽寒條。遊不曠林，宿則森標。\n晨風清興，好音時交。矰繳奚施？已卷安勞！',
  },
  {
    id: 'poem-weijin-weiguyanxianzengfushiershou',
    category: 'poem',
    dynasty: 'weijin',
    title: '爲顧彥先贈婦詩二首',
    source: '陸機',
    description: '魏晉南北朝時期經典詩歌，作者為陸機。',
    content: '【其一】\n辭家遠行遊，悠悠三行裏。\n京洛多風塵，素衣化爲緇。\n循身悼憂苦，感念同懷子。\n隆思亂心曲，沈歡滯不起。\n歡沈難克興，心亂誰爲理。\n願假歸鴻翼，翻飛浙江汜。\n【其二】\n東南有思婦，長嘆充幽闥。\n借問嘆何爲，佳人渺天末。\n遊宦久不歸，山川修且闊。\n形影參商乖，音息曠不達。\n離合非有常，譬彼弦與筈。\n願保金石軀，慰妾長飢渴。',
  },
  {
    id: 'poem-weijin-shanzaixingqier',
    category: 'poem',
    dynasty: 'weijin',
    title: '善哉行 其二',
    source: '曹操',
    description: '三國魏曹操四言/五言樂府詩名篇，展現慷慨悲涼之英雄氣概。',
    content: '自惜身薄祜，夙賤罹孤苦。\n既無三徙教，不聞過庭語。\n其窮如抽裂，自以思所怙。\n雖懷一介志，是時其能與！\n守窮者貧賤，惋嘆淚如雨。\n泣涕於悲夫，乞活安能睹？\n我願於天窮，琅邪傾側左。\n雖欲竭忠誠，欣公歸其楚。\n快人由爲嘆，抱情不得敘。\n顯行天教人，誰知莫不緒。\n我願何時隨？此嘆亦難處。\n今我將何照於光曜？釋銜不如雨。',
  },
  {
    id: 'poem-weijin-kuhanxing',
    category: 'poem',
    dynasty: 'weijin',
    title: '苦寒行',
    source: '曹操',
    description: '三國魏曹操四言/五言樂府詩名篇，展現慷慨悲涼之英雄氣概。',
    content: '北上太行山，艱哉何巍巍！\n羊腸坂詰屈，車輪爲之摧。\n樹木何蕭瑟！北風聲正悲。\n熊羆對我蹲，虎豹夾路啼。\n溪谷少人民，雪落何霏霏！\n延頸長嘆息，遠行多所懷。\n我心何怫鬱？思欲一東歸。\n水深橋樑絕，中路正徘徊。\n迷惑失故路，薄暮無宿棲。\n行行日已遠，人馬同時飢。\n擔囊行取薪，斧冰持作糜。\n悲彼東山詩，悠悠使我哀。',
  },
  {
    id: 'poem-weijin-tangshangxing',
    category: 'poem',
    dynasty: 'weijin',
    title: '塘上行',
    source: '曹操',
    description: '三國魏曹操四言/五言樂府詩名篇，展現慷慨悲涼之英雄氣概。',
    content: '蒲生我池中，其葉何離離。\n傍能行仁義，莫若妾自知。\n衆口鑠黃金，使君生別離。\n念君去我時，獨愁常苦悲。\n想見君顏色，感結傷心脾。\n念君常苦悲，夜夜不能寐。\n莫以豪賢故，棄捐素所愛？\n莫以魚肉賤，棄捐蔥與薤？\n莫以麻枲賤，棄捐菅與蒯？\n出亦復何苦，入亦復何愁。\n邊地多悲風，樹木何修修！\n從君致獨樂，延年壽千秋。',
  },
  {
    id: 'poem-weijin-wushensuiliuyuezhongyuhuo',
    category: 'poem',
    dynasty: 'weijin',
    title: '戊申歲六月中遇火',
    source: '陶淵明',
    description: '魏晉南北朝時期經典詩歌，作者為陶淵明。',
    content: '草廬寄窮巷，甘以辭華軒。\n正夏長風急，林室頓燒燔。\n一宅無遺宇，舫舟蔭門前。\n迢迢新秋夕，亭亭月將圓。\n果菜始復生，驚鳥尚未還。\n中宵佇遙念，一盼周九天。\n總髮抱孤介，奄出四十年。\n形跡憑化往，靈府長獨閒。\n貞剛自有質，玉石乃非堅。\n仰想東戶時，餘糧宿中田。\n鼓腹無所思；朝起暮歸眠。\n既已不遇茲，且遂灌我園。',
  },
  {
    id: 'classic-yushanjuyuanjuejiaoshu',
    category: 'classic',
    dynasty: 'weijin',
    title: '與山巨源絕交書',
    source: '嵇康',
    description: '魏晉「竹林七賢」嵇康拒絕入仕朝廷之宣言長文，文字剛正耿介、灑脫不羈。',
    content: '康白：足下昔稱吾於潁川，吾常謂之知言。然性有所不堪，跡有所不合，故遂不仕。近從足下卜居，意在投托，亦未敢自同於昔人。足下今欲以吾為代，是未察吾心，而強欲相率耳。吾少孤，由母親兄所嬌蚩，輕肆志意，不狎世務，性復疏懶，筋骨遲鈍，頭面常一月十五日不洗；不大癢悶，不復洗沐也。每臥即至日杲杲，寢覺猶復曚昽。性復多恚，不可任事。及長，好《老》、《莊》，賤物貴身，志在守樸。又每非湯、武，薄周、孔，在人間習之已久，若在朝廷，言必有失，不可保也。又性不喜俗人，不欲見之；俗人集聚，談論紛紜，不能不慍，若強應酬，則肢體欲木，發背成瘡。又吾胸中氣逆，發即如痛，若不自放，即發暴疾。夫以七不堪、二不可之人，而欲強使入仕，豈不相逼過甚邪！足下何宜強人所難，使之為大失邪？足下明知吾心，何至相逼如此！復具陳七不堪、二不可之意，足下可得而省也。',
  },


  {
    id: 'sutra-wuliangshou-wishes',
    category: 'sutra',
    dynasty: 'weijin',
    title: '佛說無量壽經·四八大願 (全文)',
    source: '曹魏·康僧鎧 譯',
    description: '無量壽經中法藏菩薩（阿彌陀佛前身）所發的四十八大願中最核心的第十八願「十念必生願」等章節。',
    content: '一者、國無惡道願。設我得佛，國有地獄、餓鬼、畜生者，不取正覺。二者、不墮惡趣願。設我得佛，國中天人，壽終之後，復更三惡道者，不取正覺。三者、身悉金色願.設我得佛，國中天人，身皆真金色者，不取正覺。四者、無有好醜願。設我得佛，國中天人，形色端正，無好醜者，不取正覺。五者、宿命通願。設我得佛，國中天人，不識宿命，下至知百千億那由他歲事者，不取正覺。六者、天眼通願。設我得佛，國中天人，不得天眼，下至見百千億那由他諸佛國者，不取正覺。七者、天耳通願。設我得佛，國中天人，不得天耳，下至聞百千億那由他諸佛所說，不悉受持者，不取正覺。八者、他心通願。設我得佛，國中天人，不得見他心智，下至知百千億那由他諸佛國中眾生心念者，不取正覺。九者、神足通願。設我得佛，國中天人，不得神足，於一念頃，下至不能超過百千億那由他諸佛國者，不取正覺。十者、不貪計身願。設我得佛，國中天人，若起想念，貪計身者，不取正覺。十一者、住定成正覺願。設我得佛，國中天人，不住定聚，必至滅度者，不取正覺。十二者、光明無量願。設我得佛，光明有限，下至不照百千億那由他諸佛國者，不取正覺。十三者、壽命無量願。設我得佛，壽命有能限量，下至百千億那由他劫者，不取正覺。十四者、聲聞無數願。設我得佛，國中聲聞，有能計量，乃至三千大千世界眾生，悉成緣覺，於百千劫悉共計校，知其數者，不取正覺。十五者、眷屬長壽願。設我得佛，國中天人，壽命有能限量，除其本願，修短自在。若不爾者，不取正覺。十六者、無諸不善願。設我得佛，國中天人，乃至聞有不善名者，不取正覺。十七者、諸佛稱歎願。設我得佛，十方世界無量諸佛，不悉咨嗟稱我名者，不取正覺。十八者、十念必生願。設我得佛，十方眾生，至心信樂，欲生我國，乃至十念，若不生者，不取正覺。唯除五逆，誹謗正法。十九者、臨終接引願。設我得佛，十方眾生，發菩提心，修諸功功德，至心發願，欲生我國，臨壽終時，假令不與大眾圍繞現其人前者，不取正覺。二十者、聞名繫念願。設我得佛，十方眾生，聞我名號，繫念我國，植諸德本，至心迴向，欲生我國，不果遂者，不取正覺。',
  },
]
